import React, { createRef } from "react";
import { connect } from "react-redux";
import BaseElem from "BaseElem";
import "Common.css";
import Button from "@material-ui/core/Button";
import { Close, ArrowBack } from '@mui/icons-material';
import { IconButton, Radio } from "@material-ui/core";
import {
  MSG_OPEN_VISIT_DIALOG,
  UNDEF,
  SMILEY_VISIT_DETAILS,
  API_CANCEL_VISITS,
  MSG_FETCH_VISITS,
  cA4A4A4,
  c4A4A4A,
  MSG_CLOSE_VISIT_DIALOG_FROM_END_DRAG,
  MSG_CLOSE_VISIT_DIALOG_FROM_OPEN_VISIT_DIALOG,
  MSG_CLOSE_VISIT_DIALOG_FROM_VISIT_CLICK,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL,
} from "Constants";
import { DateTimeDisplay } from "Components/DateTimeDisplay";
import {
  setDocumentScrollEnabled,
  clamp,
  blur,
  cleanTextForMobileCompatibility,
  _attr,
  isObjEmpty,
  isBlank,
} from "Util/Utilities";
import { TextDropdown } from "Components/TextDropdown";
import {
  getWeekdayName,
  nthWeekday,
  formatMultipleDates,
  getDayNames,
  dateAdd,
  getShortWeekDays,
  firstDayOfWeek,
  areDatesSame,
  formatDate,
  getSameDayNextMonth,
  isPastDate,
  parseDate,
  calculateDurationHourMinute,
  toISOLocal,
  fixVisitStartDate,
  fixVisitEndDate,
  isFutureDate,
  getTimeEntries,
  minsToMilitary,
  convertToDestTZ,
} from "Util/DateUtils";
import {
  MOBILITY_TYPES,
  NURSE_REQUIREMENTS,
  VISIT_BREAK_OPTIONS,
  MAX_CPS_FOR_VISIT,
  VISIT_SOURCE_OPTIONS,
  B2B_VISIT_SOURCE_OPTIONS,
  visit_schedule,
  visit_location_address,
  requested_services,
  meal_requirements,
  nursing_procedure,
  home_medical_details,
  companionship_description,
  home_rehabilitation,
  home_medical,
  special_requests_instructions,
  ambulant,
  breaks,
  is_nurse_required,
  is_nurse_requested,
  reason_for_nurse,
  mobility_instruction,
  has_manual_transfer,
  manual_transfer_help,
  manual_transfer_help_details,
  transfer_points,
  have_hoist,
  co_accept_2_cps,
  bed,
  transfer_type,
  required_cp,
  require_vital_sign,
  internal_ops_cr_note,
  internal_ops_fulfillment_note,
  preferred_cps,
  customer_request_origin,
  assigned_carepros,
  payment_breakdown,
  customer_requested_at,
  therapy_details,
  medical_escort_details,
  procedures,
  MEDICAL_ESCORT,
  VISIT_SOURCE_DISABLED,
  blob_urls,
  doctor_memo_available,
  doctor_memo,
  PHYSIOTHERAPY,
  SPEECH_THERAPY,
  OCCUPATIONAL_THERAPY,
  BASIC_CONSULTATION,
  expected_outcome,
  preferred_cps_list_by_service,
  APP_COUNTRY,
  isAU,
  isMY,
  isSG,
  isAppTypeB2B,
  isAppTypeB2C,
  preferred_cps_option,
} from "DataConstants";
import { LocationInput } from "Components/LocationInput";
import { InputField } from "Components/InputField";
import Calendar from "Components/CalendarView/Calendar";
import AutoAssignToggle from "Components/Dialogs/VisitDialog/AutoAssignToggle";
import _ from "lodash";

// This should be last css import
import "./style.css";
import { NursingProcedures } from "Components/NursingProcedures";
import { OkCancelDialog, TimePicker } from "Components/CommonComponents";
import DialogCompUpdateVisit, {
  UpdateVisitProps,
  ADDED_VISITS,
  REASON_FOR_CANCELLATION,
  REASON_FOR_CHANGE,
  IS_PRICING_UPDATE,
  IS_FROM_DEEPLINK,
  INITIATED_BY,
  CUSTOMER_REQUEST_DATE,
} from "../DialogCompUpdateVisit";
import Api from "Api";
import { isB2b } from "Screens/ManageCareRecipientB2C/ManageCareRecipient";
import { Div, Img, Txt } from "Components/GenericView";
import { VisitLocationAddress } from "../../../@types/PricingModels";
import DoctorsMemo from "Screens/CareOwner/MemoTask/DoctorsMemo";
import { UploadData } from "Components/SharedComponents/MultiUpload";
import PatientDeclaration, {
  havePatientDeclaration,
  PatientDeclarationDisplay,
} from "Components/PatientDeclaration/PatientDeclaration";
import MedicalEscort, {
  getMedicalEscortDetails,
} from "Components/MedicalEscort/MedicalEscort";
import {
  FeeType,
  parseFees,
  parseFeeValue,
  toNum,
} from "Components/VisitUpdateReview/VisitUpdateReview";
import {
  AdditionalRequirements,
  AdditionalRequirementsInfo,
  fixManualTransfer,
} from "../AdditionalRequirements";
import LocationDropdown from "Components/LocationDropdown";
import ADLServicesSection from "./ADLServicesSection";
import NursingProceduresSection from "./NursingProceduresSection";
import NumberOfCareProsRequired from './NumberOfCareProsRequired';
import SelectedCarePros from "./SelectedCarePros";
import SelectPreferredCarePros from "./SelectPreferredCarePros";
import {
  DIALOG_TYPE,
  PayloadVisitDialog,
  VIEW_TYPE,
  VisitRepeatMode,
  VisitDialogFullPropsType,
  VisitDialogState,
  VisitDialogStatePropsType,
  VisitDialogConnectPropsType,
} from './types';
import PreferredCareProsSubView from "./PreferredCareProsSubView";
import HardSoftPreferenceForVisitDialogue from "Components/HardSoftPreferenceForVisitDialogue";

const DEF_REPEAT_UNTIL_DAYS = 6; // default value for repeat modes
const DEF_ENDS_AFTER = 7; //occurences, days, weeks
const DEF_MAX_OCCURRENCES = 30;

const getDefaultAutoAssignToggleValue = (): boolean => {
  if (isAU) {
    return true;
  };
  if (isMY) {
    return false;
  };
  if (isSG) {
    return false;
  };
  return false;
}

class VisitDialog extends BaseElem<VisitDialogFullPropsType, VisitDialogState> {

  _onCloseCallback?: Function;
  _onVisitUpdateCallback?: Function;
  // _visit?: Visit;

  // original visit copy to compare for changes
  _orgVisit?: string;
  _isUpdate?: boolean; //is updating visits

  _innerDialogRef = createRef<any>();
  _scrollerRef = createRef<any>();
  _locRef = createRef<LocationInput>();
  _updCancelCompRef = createRef<any>();

  _reqOriginRef = createRef<any>();
  _reqLocationRef = createRef<any>();
  _reqManualTransferRef = createRef<any>();

  _isFromDeeplink = false;

  public static timeEntries: any[] = getTimeEntries();

  constructor(props: VisitDialogFullPropsType) {
    super(props);

    this.state = {
      _dialogtype: DIALOG_TYPE.NEW_VISIT,
      open: false,
      _open: false,
      _visit: {
        preferred_cps: getDefaultAutoAssignToggleValue(),
        preferred_cps_list_by_service: props.preferred_cps_list_by_service,
      },
      current_selected_preferred_care_pros: props.preferred_cps_list_by_service,
      _visitsCount: 1,
      _viewtype: VIEW_TYPE.DEFAULT,
      _repeatModes: [],
      _repeatMode: this._defaultRepeatMode(),
      _closeCallbackFrom: '',
      _renderedVisitFromBigCalendar: {},
      _eventTypeFromBigCalendar: '',
      _eventKeyFromBigCalendar: false,
      _currentVisitFromVisitDraftListView: {},
      _isApplyToAllFromVisitDraftListView: false,
    };
  }

  /**
   * Triggered when a message is received,
   **/

  _onMessageReceived = (event: any) => {
    const receivedMessage = event.data.message;
    const payload = event.data.payload;

    if (!payload || receivedMessage !== MSG_OPEN_VISIT_DIALOG) {
      return;
    };

    const self = this,
      dialogtype = payload.type;
    self._onCloseCallback = payload.closeCallback;
    self._onVisitUpdateCallback = payload.updateCallback;
    self._isUpdate = payload.isUpdate;
    const visit = payload.visit;
    const qParams = payload.deeplinkParams;

    if (visit) {
      const copy = JSON.parse(JSON.stringify(visit));
      copy.startDate = visit.startDate;
      copy.endDate = visit.endDate;

      const isNewVisit = dialogtype === DIALOG_TYPE.NEW_VISIT;
      const isExistingVisit = dialogtype === DIALOG_TYPE.VISIT_DETAILS;

      const preferredCPsValuesFromAPI = structuredClone(this.state.current_selected_preferred_care_pros);
      const preferredCPsValuesFromPreviousVisit = this.props.previousVisit?.preferred_cps_list_by_service;
      let currentPreferredCPsValue = {
        home_personal_care: [],
        home_therapy: [],
        home_medical: []
      };

      if (isNewVisit) {
        copy[customer_requested_at] = toISOLocal(new Date());

        copy.preferred_cps_list_by_service = this.assignPreferredCPListOnDialogOpenForNewVisit(preferredCPsValuesFromAPI, preferredCPsValuesFromPreviousVisit, currentPreferredCPsValue);
        currentPreferredCPsValue = this.assignPreferredCPListOnDialogOpenForNewVisit(preferredCPsValuesFromAPI, preferredCPsValuesFromPreviousVisit, currentPreferredCPsValue);
      };

      if (isExistingVisit) {
        copy.preferred_cps_list_by_service = this.assignPreferredCPListOnDialogOpenForExistingVisit(copy.preferred_cps_list_by_service, currentPreferredCPsValue);
        currentPreferredCPsValue = this.assignPreferredCPListOnDialogOpenForExistingVisit(copy.preferred_cps_list_by_service, currentPreferredCPsValue);
      };

      // setting initial visit state during opening of dialog (order of spread operator matters here)
      this.setState({ _visit: { ...this.state._visit, ...copy }, current_selected_preferred_care_pros: currentPreferredCPsValue });
    }

    const isVisitsUpdate = !!(qParams && qParams.isUpdate);
    const isPricingUpdate = !!(qParams && qParams.isUpdatePricing);
    const isVisitsCancel = !!(qParams && qParams.isCancel);
    const updateCancelVisits = qParams?.visits || [];

    const updateCancelVisitsCount = updateCancelVisits.length;
    const updateVisitsAdditionalTxt =
      updateCancelVisitsCount > 1 ? `s (${updateCancelVisitsCount})` : "";
    self._isFromDeeplink = false;

    let updateVisitProps: any;
    if (!isBlank(updateCancelVisits)) {
      updateVisitProps = {};
      if (isVisitsCancel) {
        updateVisitProps[REASON_FOR_CANCELLATION] =
          qParams?.cancellationReason;
      } else if (isVisitsUpdate || isPricingUpdate) {
        updateVisitProps[REASON_FOR_CHANGE] = qParams?.changeReason;
      }
      if (isPricingUpdate) {
        updateVisitProps[IS_PRICING_UPDATE] = true;
      }
      self._isFromDeeplink = true;
      updateVisitProps[IS_FROM_DEEPLINK] = true;
      updateVisitProps.pre_selected_visit_ids = qParams?.visitIds;
    }

    self.setState({
      _dialogtype: dialogtype,
      _isUpdating: isVisitsUpdate || isPricingUpdate,
      _updatingVisitsTitle: updateVisitsAdditionalTxt,
      _updateVisitProps: updateVisitProps,
      _closeCallbackFrom: payload.closeCallbackFrom,
      _renderedVisitFromBigCalendar: payload?.renderedVisit,
      _eventTypeFromBigCalendar: payload?.eventType,
      _eventKeyFromBigCalendar: payload?.mouseEventAltKey,
      _currentVisitFromVisitDraftListView: payload?.currentVisit,
      _isApplyToAllFromVisitDraftListView: payload?.isApplyToAll,
    });

    self.open(self.state._visit, payload.anchor, dialogtype);
    if (dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS) {
      self._switchView(VIEW_TYPE.ADDITIONAL_DETAILS);
    } else if (dialogtype === DIALOG_TYPE.MEDICAL_ESCORT_DETAILS) {
      self._switchView(VIEW_TYPE.MED_ESCORT_DETAILS);
    } else if (dialogtype === DIALOG_TYPE.PATIENT_DECLARATION) {
      self._switchView(VIEW_TYPE.PATIENT_DECLARATION);
    } else if (isVisitsCancel) {
      self.async(() => self._switchView(VIEW_TYPE.CANCEL_VISIT));
    } else if (isPricingUpdate) {
      self.async(() => self._switchView(VIEW_TYPE.UPDATE_VISIT));
    } else if (dialogtype === DIALOG_TYPE.PREFERRED_CARE_PROS) {
      self._switchView(VIEW_TYPE.PREFERRED_CARE_PROS);
    }

  };

  // Setup event listeners
  _enableListeners(isEnabled = false) {
    this.setListeners(isEnabled, MSG_OPEN_VISIT_DIALOG);
    //TODO: handle window resize as well
  }

  componentDidMount() {
    // LIFECYCLE
    this._enableListeners(true);
    window.addEventListener("message", this._onMessageReceived);
  };

  componentWillUnmount() {
    // LIFECYCLE
    this._enableListeners(false);
    window.removeEventListener("message", this._onMessageReceived);
  };

  assignPreferredCPListOnDialogOpenForNewVisit(listFromAPI: any, listFromPreviousVisit: any, defaultList: any) {
    if (listFromPreviousVisit) {
      return listFromPreviousVisit;
    };

    if (listFromAPI) {
      return listFromAPI;
    };

    return defaultList;
  };

  assignPreferredCPListOnDialogOpenForExistingVisit(existingPreferredCPList: any, defaultPreferredCPList: any) {
    if (existingPreferredCPList) {
      // 1. Take visit values
      return existingPreferredCPList;
    };
    // 2. OR if none, then use default values
    return defaultPreferredCPList;
  };

  _setPreferredCareProToggleValue = (previousVisitValue: boolean | undefined) => {
    if (isSG) {
      // SG priorities previousVisit value if one exists.
      return previousVisitValue;
    }
    if (isMY) {
      return getDefaultAutoAssignToggleValue();
    }
    if (isAU) {
      return getDefaultAutoAssignToggleValue();
    }
  }

  _renderVisit(visit: any, dialogtype: DIALOG_TYPE) {
    const self = this,
      props = self.props,
      prevVisit = props.previousVisit;

    const keysToCopyFromPreviousVisit = [
      home_rehabilitation,
      home_medical,
      nursing_procedure,
      requested_services,
      meal_requirements,
      visit_location_address,
      ambulant,
      mobility_instruction,
      has_manual_transfer,
      require_vital_sign,
      manual_transfer_help,
      manual_transfer_help_details,
      co_accept_2_cps,
      have_hoist,
      transfer_points,
      bed,
      transfer_type,
      is_nurse_required,
      is_nurse_requested,
      reason_for_nurse,
      special_requests_instructions,
      required_cp,
      breaks,
      internal_ops_cr_note,
      internal_ops_fulfillment_note,
      preferred_cps,
      preferred_cps_list_by_service,
      therapy_details,
      medical_escort_details,
      home_medical_details,
      companionship_description,
      preferred_cps_option
    ];

    //const isNewVisit = dialogtype === DIALOG_TYPE.NEW_VISIT;
    const switchToAdditionalRequirements =
      dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS;
    const switchToMedEscort = dialogtype === DIALOG_TYPE.MEDICAL_ESCORT_DETAILS;
    const switchToPatientDecl = dialogtype === DIALOG_TYPE.PATIENT_DECLARATION;
    const switchToSubDialog =
      switchToAdditionalRequirements ||
      switchToMedEscort ||
      switchToPatientDecl;

    const isReadOnly = dialogtype === DIALOG_TYPE.VISIT_DETAILS;

    // Copy values from previous visit
    if (!isReadOnly && !switchToSubDialog && prevVisit) {
      for (let i = keysToCopyFromPreviousVisit.length; i--;) {
        const key = keysToCopyFromPreviousVisit[i];
        if (visit[key] === UNDEF) {
          visit[key] = prevVisit[key];
        }
      }

      if (Object.hasOwn(prevVisit, preferred_cps)) {
        // use previous visit value if one exists (otherwise it remains default)
        visit[preferred_cps] = prevVisit[preferred_cps];
      }

      if (Object.hasOwn(prevVisit, preferred_cps_list_by_service)) {
        // use previous visit value if one exists (otherwise it remains default)
        visit[preferred_cps_list_by_service] = prevVisit?.preferred_cps_list_by_service;
      }

      if (self._isTherapyDisabled(visit)) {
        visit[home_rehabilitation] = [];
        //delete visit[therapy_details];
      } else {
        const selectedTherapy = (visit[home_rehabilitation] || [])[0];
        if (selectedTherapy) {
          // only need first entry
          visit[home_rehabilitation] = [selectedTherapy];
        }

        // create a copy of doctor memo
        const therapyDetails = visit[therapy_details];
        if (therapyDetails) {
          therapyDetails[blob_urls] = (
            therapyDetails[doctor_memo] || []
          ).slice();
        }
      }
      if (self._isHomeMedicalDisabled(visit)) {
        visit[home_medical] = [];
        //delete visit[home_medical_details];
      }

      if (visit[nursing_procedure] && visit[nursing_procedure][0]) {
        visit[is_nurse_required] = true;
        if (visit[is_nurse_requested]) {
          visit[is_nurse_requested] = false;
        }
        visit[reason_for_nurse] =
          visit[reason_for_nurse] || "Nursing Procedures selected";
      }

      // Remove "Medical Escort" from adl services when medical escort details aren't available
      const medEscortDetails = visit[medical_escort_details];
      if (isObjEmpty(medEscortDetails)) {
        const adls = visit[requested_services];
        visit[requested_services] = adls.filter(
          (adl: string) => adl !== MEDICAL_ESCORT
        );
      }
    } else if (visit[therapy_details]) {
      const therapyDetails = visit[therapy_details];
      therapyDetails[blob_urls] = (therapyDetails[doctor_memo] || []).slice();
    }

    const schedule = visit[visit_schedule];
    if (schedule) {
      visit.startDate = parseDate(schedule.date_from);
      visit.endDate = parseDate(schedule.date_to);
    }

    if (!visit[required_cp]) {
      visit[required_cp] = 1;
    }

    // when vwo have breaks set default to 1 hour
    if ((props.crInfo || {}).has_breaks && !visit[breaks]) {
      visit[breaks] = visit[breaks] || "1";
    }

    let visitLocation: any = visit[visit_location_address] || {};
    if (!visitLocation.country) {
      visitLocation.country = APP_COUNTRY;
      visit[visit_location_address] = visitLocation;
    }

    self.setState({
      _visit: visit,
      _visitsCount: self._generateVisits(true).length,
    });

    self._updateRepeatModes();

    // make a copy to compare for changes
    self._orgVisit = JSON.stringify(visit);
  }

  _setOpen(isOpen: boolean, dialogtype: DIALOG_TYPE) {
    this.setState({
      open: isOpen,
      _isReadOnly: dialogtype === DIALOG_TYPE.VISIT_DETAILS,
    });
    this.async(() => this.setState({ _open: isOpen }), 200);
    setDocumentScrollEnabled(!isOpen);
  }

  open(visit: any, anchor: any, dialogtype: DIALOG_TYPE) {
    const self = this;
    self._setOpen(true, dialogtype);
    self._renderVisit(visit, dialogtype);
    self._positionPopup(anchor);
    self.async(() => self._positionPopup(anchor), 1);
    self._setInitialTextHeight();
  }

  _positionPopup(anchor: any) {
    const self = this;

    // Position dialog
    const dialog = self._innerDialogRef.current as HTMLElement;
    if (!dialog) return;

    const dialogStyle = dialog.style;

    const availWidth = window.innerWidth;
    const availHeight = window.innerHeight;

    const dialogWidth = dialog.offsetWidth;
    const dialogHeight = dialog.offsetHeight;

    if (!anchor) {
      anchor = {
        width: 0,
        x: (dialogWidth + availWidth) / 2,
        top: availHeight / 2,
      };
    }

    let left = "",
      right = "";

    // align left
    if (anchor.x > dialogWidth) {
      right = ((availWidth - anchor.x - 2) * 100) / availWidth + "%";
      dialogStyle.transform = "";
    } else if (availWidth - (anchor.x + anchor.width) > dialogWidth) {
      dialogStyle.transform = "translateX(-10px)";
      left = ((anchor.width + anchor.x - 14) * 100) / availWidth + "%";
    } else {
      left = "10px";
    }

    const minVal = 16;
    const maxTop = availHeight - dialogHeight - minVal;
    const top = (clamp(anchor.top, minVal, maxTop) * 100) / availHeight + "%";

    dialogStyle.top = top;
    dialogStyle.left = left;
    dialogStyle.right = right;
  }

  close(cancelled = true, isApplyAll = false) {
    const self = this,
      state = self.state;
    const closeCallback: any = self._onCloseCallback;

    const dialogtype = state._dialogtype;
    const isAdditionalReq = dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS;
    const isMedEscort = dialogtype === DIALOG_TYPE.MEDICAL_ESCORT_DETAILS;
    const isPatientDecl = dialogtype === DIALOG_TYPE.PATIENT_DECLARATION;
    const isPreferredCPDlg = dialogtype === DIALOG_TYPE.PREFERRED_CARE_PROS;
    const isSubDialog = isAdditionalReq || isMedEscort || isPatientDecl || isPreferredCPDlg;

    const visitFromState = self._includePreferredCPsValuesInVisitIfConditionsAreMet(self.state._visit);

    self._setOpen(false, DIALOG_TYPE.NEW_VISIT);
    const dialogStyle = self._innerDialogRef.current?.style || {};
    dialogStyle.transform = "";
    let visits =
      cancelled || state._isReadOnly
        ? []
        : isSubDialog
          ? [visitFromState]
          : self._generateVisits();

    // closeCallback && closeCallback(visits, isApplyAll);

    const { _closeCallbackFrom } = state;

    // messages for returning to Big Calendar 
    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_VISIT_CLICK) {
      const payload = {
        popupVisits: visits,
        isApplyAll: isApplyAll,
        renderedVisit: this.state._renderedVisitFromBigCalendar,
      };

      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_VISIT_CLICK,
        payload
      }, "/");
    };

    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_END_DRAG) {
      const payload = {
        popupVisits: visits,
        isApplyAll: isApplyAll,
        eventType: this.state._eventTypeFromBigCalendar,
        eventKey: this.state._eventKeyFromBigCalendar,
      };

      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_END_DRAG,
        payload
      }, "/");
    };

    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_OPEN_VISIT_DIALOG) {
      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_OPEN_VISIT_DIALOG
      }, "/");
    };

    // messages for returning to list view (visit draft)
    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS) {
      const payload = {
        popupVisits: visits,
        isApplyAll: isApplyAll,
        currentVisit: this.state._currentVisitFromVisitDraftListView,
        isApplyToAll: this.state._isApplyToAllFromVisitDraftListView,
      };

      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS,
        payload
      }, "/");
    };

    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT) {
      const payload = {
        popupVisits: visits,
        isApplyAll: isApplyAll,
        currentVisit: this.state._currentVisitFromVisitDraftListView,
        isApplyToAll: this.state._isApplyToAllFromVisitDraftListView,
      };

      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT,
        payload
      }, "/");
    };

    if (_closeCallbackFrom === MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL) {
      const payload = {
        popupVisits: visits,
        isApplyAll: isApplyAll,
        currentVisit: this.state._currentVisitFromVisitDraftListView,
        isApplyToAll: this.state._isApplyToAllFromVisitDraftListView,
      };

      postMessage({
        message: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL,
        payload
      }, "/");
    };

    //Auto move to listview
    if (!isSubDialog && !cancelled && !state._isReadOnly) {
      const moveToListViewCallback = self.props.moveToListView;
      moveToListViewCallback && moveToListViewCallback(visits);
    }
    self._cleanup();
  }

  _showConfirmation(show = true) {
    const self = this;
    const visitChanged = self._orgVisit !== JSON.stringify(self.state._visit);
    if (visitChanged) {
      self.setState({ _showConfirmation: show });
    } else {
      self.close(true);
    }
  }

  _onDiscardChanges(discard = false) {
    const self = this;
    self._showConfirmation(false);
    discard && self.close(true);
  }

  // cleanup after close
  _cleanup() {
    const self = this;
    const props = self.props;
    self._onCloseCallback = UNDEF;
    self._onVisitUpdateCallback = UNDEF;
    self._orgVisit = UNDEF;
    self._isUpdate = false;
    self._locRef.current?.blur();

    self.setState({
      _repeatMode: self._defaultRepeatMode(),
      _dialogtype: DIALOG_TYPE.NEW_VISIT,
      _viewtype: VIEW_TYPE.DEFAULT,
      _visitsCount: 1,
      _updateVisitProps: UNDEF,
      _showErrors: UNDEF,
      _isUpdating: false,
      _visit: {
        preferred_cps: getDefaultAutoAssignToggleValue(),
        preferred_cps_list_by_service: props.preferred_cps_list_by_service,
      },
      current_selected_preferred_care_pros: props.preferred_cps_list_by_service,
      _repeatModes: [],
      _closeCallbackFrom: '',
      _renderedVisitFromBigCalendar: {},
      _eventTypeFromBigCalendar: '',
      _eventKeyFromBigCalendar: false,
      _currentVisitFromVisitDraftListView: {},
      _isApplyToAllFromVisitDraftListView: false,
    });
  }

  _onDatesChange = (startDate: Date, endDate: Date) => {
    const self = this,
      visit = self.state._visit;

    // Start date should be multiple of 15 mins
    if (startDate) {
      visit.startDate = fixVisitStartDate(startDate);
    }

    // validate duration
    // min 30 mins, max 24 hours, duration should be multiple of 15 mins
    visit.endDate = fixVisitEndDate(visit.startDate, endDate || visit.endDate);

    // reset repeatMode to "Do not repeat" when dates change
    self.setState({ _repeatMode: self._defaultRepeatMode() });

    self.setState({ _visit: visit });
    self.async(() => self._updateRepeatModes());

    return { startDate: visit.startDate, endDate: visit.endDate };
  };

  _updateRepeatModes() {
    const self = this,
      startDate = self.state._visit.startDate;
    const repeatModes = [
      "Does not repeat",
      "Daily",
      `Weekly on ${getWeekdayName(startDate)}`,
      `Monthly on ${nthWeekday(startDate)}`,
      "Custom...",
    ];

    let currentMode = self.state._repeatMode;

    self.setState({
      _repeatModes: repeatModes,
      _repeatMode: currentMode,
      _visitsCount: self._generateVisits(true).length,
    });
  }

  _defaultRepeatMode(): VisitRepeatMode {
    return {
      is_custom: false,
      repeat_count: 1,
      repeat_type: "no-repeat",
    };
  }

  // _viewtypeChange
  _repeatModeChange(selectedItem: string) {
    const self = this;
    let viewtype = self.state._viewtype,
      CUSTOM_REPEAT = VIEW_TYPE.CUSTOM_REPEAT;
    if (self._getDatesValidationError(self.state._visit)) return;

    // current repeat mode
    const type = self.state._repeatMode.repeat_type;
    const DAY = "Day",
      WEEK = "Week",
      MONTH = "Month";

    let repeatMode = self._defaultRepeatMode();

    if (selectedItem === "Daily") {
      viewtype = CUSTOM_REPEAT;
      if (type !== DAY) {
        repeatMode = self._getCustomRepeatMode(DAY, true);
        self.async(() => self._renderRepeatDays());
      } else {
        repeatMode = self._getCustomRepeatMode();
      }
    } else if (selectedItem.startsWith("Weekly")) {
      viewtype = CUSTOM_REPEAT;
      repeatMode = self._getCustomRepeatMode(WEEK, type !== WEEK);
    } else if (selectedItem.startsWith("Monthly")) {
      viewtype = CUSTOM_REPEAT;
      repeatMode = self._getCustomRepeatMode(MONTH, type !== MONTH);
    } else if (selectedItem.startsWith("Custom")) {
      viewtype = CUSTOM_REPEAT;
      repeatMode = self._getCustomRepeatMode(type);
      type === DAY && self.async(() => self._renderRepeatDays());
    }

    self.setState({
      _repeatMode: repeatMode,
      _viewtype: viewtype,
    });

    self.debounce(self._generateVisitCount.bind(self), 100);
    self._enableAnimations();
  }

  _getCustomRepeatMode(repeattype = "Week", reset = false): VisitRepeatMode {
    const self = this,
      visit = self.state._visit,
      visitStart = visit && visit.startDate;

    let lastValidDate = new Date();
    const startDay = visitStart && visitStart.getDay();

    if (visitStart) {
      lastValidDate = new Date(visitStart);
    }

    // repetition ends after 7 days by default
    lastValidDate.setDate(lastValidDate.getDate() + DEF_REPEAT_UNTIL_DAYS);

    const currentRepeatMode = self.state._repeatMode;

    // prepare default values for custom repeat mode
    const repeatMode: VisitRepeatMode =
      currentRepeatMode.is_custom && !reset
        ? currentRepeatMode
        : {
          is_custom: true,
          repeat_count: 1,
          repeat_type: repeattype === "no-repeat" ? "Week" : repeattype,
          repeat_on: startDay !== UNDEF ? [startDay] : [new Date().getDay()],

          repeat_on_month_day: true,
          is_ending_exact_date: true,
          ends_on_date: lastValidDate,
          ends_after: DEF_ENDS_AFTER,
          ends_after_type: self._getAftertypes(1)[0],
        };

    return repeatMode;
  }

  _getRepeatModeText(repeatMode: VisitRepeatMode): string {
    const self = this,
      repeatModes = self.state._repeatModes;
    const type = repeatMode.repeat_type;
    if (type === "no-repeat") return repeatModes[0];
    const isDay = type === "Day";
    const isWeek = type === "Week";
    const isMonth = type === "Month";
    const repeatCount = repeatMode.repeat_count;
    //const visitCount = ` (${(self._generateVisits(true)).length} visits)`;

    if (!repeatMode.is_custom) {
      const idx = isDay ? 1 : isWeek ? 2 : 3;
      return repeatModes[idx]; // + visitCount;
    }

    // custom repeat modes below
    if (isDay) {
      return "On " + formatMultipleDates(repeatMode.custom_dates || []); // + visitCount;
    } else if (isWeek) {
      const repeatDays = (repeatMode.repeat_on || [])
        .sort()
        .map((i) => getDayNames()[i].substr(0, 3))
        .join(", ");
      let endsAt = "";

      if (repeatMode.is_ending_exact_date) {
        endsAt = " until " + formatDate(repeatMode.ends_on_date);
      } else if (repeatMode.ends_after_type === "occurrence") {
        endsAt = `, ${repeatMode.ends_after} time${(repeatMode.ends_after || 1) > 1 ? "s" : ""
          }`;
      }

      if (repeatCount === 1) {
        return "Weekly on " + repeatDays + endsAt;
      } else {
        return `Every ${repeatCount} weeks on ${repeatDays}${endsAt}`;
      }
    } else if (isMonth) {
      const startDate = self.state._visit?.startDate || new Date();
      if (repeatMode.repeat_on_month_day) {
        return `Monthly on day ${startDate.getDate()}`; // + visitCount;
      } else {
        return `Monthly on ${nthWeekday(startDate)}`; // + visitCount;
      }
    }
    return "";
  }

  _onRepeatCountChange(countStr: string) {
    const self = this;
    const count = clamp(parseInt(countStr) || 1, 1, DEF_MAX_OCCURRENCES);
    const repeatMode = self._getCustomRepeatMode();
    repeatMode.repeat_count = count;
    self.setState({ _repeatMode: repeatMode });
    self.async(() => self._renderRepeatDays());
  }

  _getRepeattypes() {
    const repeatMode = this._getCustomRepeatMode();
    const types = ["Day", "Week", "Month"];
    return repeatMode.repeat_count <= 1
      ? types
      : types.map((t: string) => t + "s");
  }

  // Repeat mode dropdown clicked (day, week, month)
  _onRepeattypeChange(type: string) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    repeatMode.repeat_type = type.replace("s", "");

    self.setState({ _repeatMode: repeatMode });
    self.async(() => self._renderRepeatDays());
  }

  // weekday clicked: day = index 0,1,2,3,4,5,6
  _onWeekDayClick(day: number) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    const repeatOn = repeatMode.repeat_on || [];
    const index = repeatOn.indexOf(day);
    if (index >= 0) {
      // can't remove the last one for validation purposes
      repeatOn.length > 1 && repeatOn.splice(index, 1);
    } else {
      repeatOn.push(day);
    }

    repeatMode.repeat_on = repeatOn;
    self.setState({
      _repeatMode: repeatMode,
      _visitsCount: self._generateVisits(true).length,
    });
  }

  _onRepeatModeDateSelected(date: Date) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    const dates = repeatMode.custom_dates || [];
    const idx = dates.findIndex((d: Date) => areDatesSame(d, date));

    if (idx === -1) {
      dates.push(date);
    } else {
      dates.splice(idx, 1);
    }
    repeatMode.custom_dates = dates;
    self.setState({
      _repeatMode: repeatMode,
      _visitsCount: dates.length,
    });
  }

  _generateVisitCount() {
    this.setState({ _visitsCount: this._generateVisits(true).length });
  }

  _renderRepeatDays() {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    const visitDate = self.state._visit && self.state._visit.startDate;

    if (!visitDate || !repeatMode.repeat_type.startsWith("Day")) {
      self._generateVisitCount();
      return;
    }

    const count = repeatMode.repeat_count;
    const dates = [];
    let startFrom: Date | null = new Date(visitDate);

    if (repeatMode.is_ending_exact_date) {
      const endsAtDate = repeatMode.ends_on_date;
      if (!endsAtDate) return;

      endsAtDate.setHours(visitDate.getHours());
      endsAtDate.setMinutes(visitDate.getMinutes());

      while (startFrom && startFrom.getTime() <= endsAtDate.getTime()) {
        dates.push(startFrom);
        startFrom = dateAdd(startFrom, count);
      }
    } else {
      let afterCount = repeatMode.ends_after;
      const endsAftertype = repeatMode.ends_after_type;
      const aftertypes = self._getAftertypes();
      if (!afterCount || !endsAftertype) return;

      // occurrence
      if (endsAftertype === aftertypes[0]) {
        while (startFrom && afterCount--) {
          dates.push(startFrom);
          startFrom = dateAdd(startFrom, count);
        }
      }
      // day
      else if (endsAftertype === aftertypes[1]) {
        while (startFrom && afterCount >= 0) {
          dates.push(startFrom);
          startFrom = dateAdd(startFrom, count);
          afterCount -= count;
        }
      }
      // week
      else if (endsAftertype === aftertypes[2]) {
        while (startFrom && afterCount >= 0) {
          dates.push(startFrom);
          startFrom = dateAdd(startFrom, count);
          afterCount -= count / 7;
        }
      }
    }

    repeatMode.custom_dates = dates;
    self.setState({
      _repeatMode: repeatMode,
      _visitsCount: dates.length,
    });
  }

  _getMonthlyDropdownItems() {
    const visit = this.state._visit;
    if (!visit) return [];

    return [
      `Monthly on Day ${visit.startDate.getDate()}`,
      `Monthly on ${nthWeekday(visit.startDate)}`,
    ];
  }
  _onMonthlyDropdownClick(type: string) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    repeatMode.repeat_on_month_day = type.indexOf(" Day ") > 0;
    self.setState({ _repeatMode: repeatMode });
    self.async(() => self._renderRepeatDays());
  }

  _onEndstypeChange(isOn: boolean) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    if (repeatMode.is_ending_exact_date !== isOn) {
      repeatMode.is_ending_exact_date = isOn;
      self.setState({ _repeatMode: repeatMode });
      self.async(() => self._renderRepeatDays());
    }
  }

  _onEndsOnDateChange(date: Date) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    const prevDate = repeatMode.ends_on_date;
    if (!prevDate || prevDate.getTime() !== date.getTime()) {
      repeatMode.ends_on_date = date;
      self.setState({ _repeatMode: repeatMode });
      self.async(() => self._renderRepeatDays());
    }
  }
  _onEndsAfterCountChange(countStr: string) {
    const self = this;
    const count = clamp(
      parseInt(countStr) || DEF_ENDS_AFTER,
      1,
      DEF_MAX_OCCURRENCES
    );
    const repeatMode = self._getCustomRepeatMode();
    if (repeatMode.ends_after !== count) {
      repeatMode.ends_after = count;
      self.setState({ _repeatMode: repeatMode });
      self.async(() => self._renderRepeatDays());
    }
  }
  _getAftertypes(count = 1) {
    const types = ["occurrence", "day", "week"];
    return count <= 1 ? types : types.map((t: string) => t + "s");
  }
  // After type dropdown clicked (occurrence, day, week)
  _onAftertypeChange(type: string) {
    const self = this;
    const repeatMode = self._getCustomRepeatMode();
    const newtype = type.replace("s", "");
    if (repeatMode.ends_after_type !== newtype) {
      repeatMode.ends_after_type = newtype;
      self.setState({ _repeatMode: repeatMode });
      self.async(() => self._renderRepeatDays());
    }
  }

  // Generate Visit(s) On bottom right Done button press
  _generateVisits(computeOnly = false): any[] {
    const self = this,
      repeatMode = self.state._repeatMode,
      visitFromState = structuredClone(self.state._visit),
      type = repeatMode.repeat_type;

    const visit = self._includePreferredCPsValuesInVisitIfConditionsAreMet(visitFromState);
    // const visit = visitFromState;

    if (self._getDatesValidationError(visit)) {
      return [];
    }

    !computeOnly && fixManualTransfer(visit);

    // Generate a copy of the visit based on new start/end dates
    const copyVisit = (visit: any, startDate: Date, endDate: Date) => {
      if (computeOnly) {
        return {
          startDate: startDate,
          endDate: endDate,
        };
      }

      startDate.setSeconds(0);
      endDate.setSeconds(0);

      const visitCopy = JSON.parse(JSON.stringify(visit));
      visitCopy.startDate = startDate;
      visitCopy.endDate = endDate;

      const visitSchedule: any = {};
      visitSchedule.date_from = toISOLocal(startDate);
      visitSchedule.date_to = toISOLocal(endDate);
      visitCopy[visit_schedule] = visitSchedule;

      return visitCopy;
    };

    // do not repeat
    if (type === "no-repeat")
      return [copyVisit(visit, visit.startDate, visit.endDate)];

    const isDay = type === "Day";
    const isWeek = type === "Week";
    const isMonth = type === "Month";
    const isCustom = repeatMode.is_custom;
    const repeatCount = repeatMode.repeat_count;
    const endsOnExactDate = repeatMode.is_ending_exact_date;

    let startDate = visit.startDate,
      endDate = visit.endDate;
    const hours = startDate.getHours(),
      mins = startDate.getMinutes();
    const dateDiff = endDate - startDate;

    let lastValidDate: Date | undefined;
    if (isCustom && endsOnExactDate) {
      lastValidDate = repeatMode.ends_on_date;
    }
    // default to 1 week later
    if (!lastValidDate) {
      lastValidDate = new Date(startDate);
      lastValidDate.setDate(lastValidDate.getDate() + DEF_REPEAT_UNTIL_DAYS);
    }

    lastValidDate.setHours(hours);
    lastValidDate.setMinutes(mins);

    let afterOccurrenceCount = repeatMode.ends_after || 0;
    const endsAftertype = repeatMode.ends_after_type || "";
    const aftertypes = self._getAftertypes(); // occurrences, days, weeks

    const visits: any[] = [];
    const pastVisits: any[] = [];

    const addVisit = (visit: any, startDate?: any, endDate?: any) => {
      if (startDate && endDate) {
        visits.push(copyVisit(visit, startDate, endDate));
        if (isPastDate(startDate, true) || isPastDate(endDate, true))
          pastVisits.push(visits);
      } else {
        visits.push(copyVisit(visit, visit.startDate, visit.endDate));
      }
    };

    if (isDay) {
      if (!isCustom) {
        addVisit(visit);
        while (startDate.getTime() < lastValidDate.getTime()) {
          startDate = dateAdd(startDate, repeatCount);
          endDate = dateAdd(endDate, repeatCount);
          addVisit(visit, startDate, endDate);
        }
      } else {
        const customDates = repeatMode.custom_dates;
        for (let k = 0; customDates && k < customDates.length; k++) {
          const sDate = customDates[k];
          sDate.setHours(hours);
          sDate.setMinutes(mins);
          const eDate = new Date(sDate.getTime() + dateDiff);
          addVisit(visit, sDate, eDate);
        }
      }
    } else {
      // handle days & week (Ends after dropdown)

      const endAfterDaysDate = dateAdd(startDate, afterOccurrenceCount);
      const endAfterWeeksDate = dateAdd(startDate, afterOccurrenceCount * 7);
      endAfterDaysDate && endAfterDaysDate.setHours(hours);
      endAfterDaysDate && endAfterDaysDate.setMinutes(mins);
      endAfterWeeksDate && endAfterWeeksDate.setHours(hours);
      endAfterWeeksDate && endAfterWeeksDate.setMinutes(mins);

      const isLoopValid = () => {
        if ((!isCustom || endsOnExactDate) && lastValidDate) {
          return startDate.getTime() <= lastValidDate.getTime();
        }
        if (endsOnExactDate) return false;

        // occurrence
        if (endsAftertype === aftertypes[0]) {
          return afterOccurrenceCount > 0;
        }

        // day
        else if (endsAftertype === aftertypes[1] && endAfterDaysDate) {
          return startDate.getTime() <= endAfterDaysDate.getTime();
        }

        // week
        else if (endsAftertype === aftertypes[2] && endAfterWeeksDate) {
          return startDate.getTime() <= endAfterWeeksDate.getTime();
        }

        return false;
      };

      if (isWeek) {
        const repeatDays = repeatMode.repeat_on || [];
        const repeatDaysCount = repeatDays.length;

        while (isLoopValid()) {
          if (repeatDays.indexOf(startDate.getDay()) >= 0) {
            addVisit(visit, startDate, endDate);
            afterOccurrenceCount--;

            // jump to nth week based on repeat count
            const visitsCount = visits.length;
            if (
              visitsCount &&
              visitsCount % repeatDaysCount === 0 &&
              repeatCount > 1
            ) {
              const increment = 7 * repeatCount - 1;
              const firstRepeatVisit = visits[visitsCount - repeatDaysCount];
              startDate = dateAdd(firstRepeatVisit.startDate, increment);
              endDate = dateAdd(firstRepeatVisit.endDate, increment);
            }
          }

          startDate = dateAdd(startDate, 1);
          endDate = dateAdd(endDate, 1);
        }
      } else if (isMonth) {
        addVisit(visit);
        afterOccurrenceCount--;

        const isRepeatOnSpecificDate = repeatMode.repeat_on_month_day;
        const repeatOnDate = startDate.getDate();
        let repeat = repeatCount;

        while (isLoopValid()) {
          if (isRepeatOnSpecificDate) {
            startDate = dateAdd(startDate, 1);
            endDate = dateAdd(endDate, 1);
            if (
              startDate.getDate() === repeatOnDate &&
              repeat-- === 1 &&
              isLoopValid()
            ) {
              repeat = repeatCount;
              afterOccurrenceCount--;
              addVisit(visit, startDate, endDate);
              startDate = dateAdd(startDate, 27);
              endDate = dateAdd(endDate, 27);
            }
          }
          //repeat on: 2nd tue, 3rd wed, last fri etc...
          else {
            startDate = getSameDayNextMonth(visit.startDate, startDate);
            endDate = new Date(
              startDate.getTime() +
              visit.endDate.getTime() -
              visit.startDate.getTime()
            );
            if (isLoopValid() && repeat-- === 1) {
              addVisit(visit, startDate, endDate);
              repeat = repeatCount;
              afterOccurrenceCount--;
            }
          }
        }
      }
    }

    return visits
      .filter((v) => pastVisits.indexOf(v) === -1)
      .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
  }

  _locationChange(updatedLocation: VisitLocationAddress) {
    const self = this,
      visit = self.state._visit;
    if (visit) {
      visit[visit_location_address] = updatedLocation;
      self.setState({ _visit: visit });
    }
  }

  _onPropChangeThatProducesArrayOutput = (prop: string, text: string | undefined) => {
    const self = this,
      visit = self.state._visit;

    if (text?.length === 0) {
      delete visit[prop];
    } else {
      visit[prop] = (cleanTextForMobileCompatibility(text) || "").split(/, |,/);
    }

    self.setState({ _visit: visit });
  }

  // For special_requests_instructions, mobility_instruction, manual_transfer_help_details, transfer_points, cr_notes, cr_fulfilment
  _onPropChange = (prop: string, text: string | undefined) => {
    const self = this,
      visit = structuredClone(self.state._visit);

    visit[prop] = cleanTextForMobileCompatibility(text);

    self.setState({ _visit: visit });
  };

  _onPreferredCpsSelect = (toggleValue: boolean) => {
    const self = this,
      visit = structuredClone(self.state._visit);

    visit[preferred_cps] = toggleValue;

    self.setState({
      _visit: visit,
    });
  };

  _mobilitytypeChange(_: any, selectedItem: string) {
    const self = this,
      visit = self.state._visit;
    visit[ambulant] = selectedItem && selectedItem.split(":")[0];
    self.setState({ _visit: visit });
  }

  _visitBreakText(breakValue: any) {
    if (!breakValue || !parseFloat(breakValue)) return VISIT_BREAK_OPTIONS[0];
    return VISIT_BREAK_OPTIONS.find((v) => v.indexOf(breakValue + " ") >= 0);
  }

  _visitBreakChange(selectedItem: string) {
    const self = this,
      visit = self.state._visit;
    visit[breaks] = (parseFloat(selectedItem) || 0) + "";
    self.setState({ _visit: visit });
  }

  // List of all Available ADL Services
  _getAdlList(data: any) {
    return !data || !data.services ? [] : data.services;
  }

  _onAdlChange = (requestedServices: any[], mealRequirements: any[]) => {
    const self = this,
      visit = self.state._visit;
    if (!visit) return;
    visit[requested_services] = requestedServices;
    visit[meal_requirements] = mealRequirements;

    // clear therapy selection
    if (requestedServices.length) {
      visit[home_rehabilitation] = [];
      visit[home_medical] = [];
      //delete visit[home_medical_details];
      //delete visit[therapy_details];
    }

    if (!(requestedServices || []).includes(MEDICAL_ESCORT)) {
      delete visit[medical_escort_details];
    } else {
      if (isObjEmpty(visit[medical_escort_details])) {
        self._switchView(VIEW_TYPE.MED_ESCORT_DETAILS);
      }
    }

    self.setState({ _visit: visit });
  };

  _onProceduresChange = (procs: any[]) => {
    const self = this,
      visit = self.state._visit;
    if (!visit) return;

    const procedures = procs.slice();
    visit[nursing_procedure] = procedures;

    // clear therapy selection
    if (procedures.length) {
      visit[home_rehabilitation] = [];
      visit[home_medical] = [];
      //delete visit[home_medical_details];
      //delete visit[therapy_details];
    }

    self.setState({ _visit: visit });
    self._updateNurseRequirements();
  };

  _onHomeMedProceduresChange = (procs: any[]) => {
    const self = this,
      visit = self.state._visit;
    if (!visit) return;

    const list = procs.slice();
    visit[home_medical_details] = visit[home_medical_details] || {};
    visit[home_medical_details][procedures] = list;

    // clear therapy selection
    if (list.length) {
      visit[home_rehabilitation] = [];
      // delete visit[therapy_details];
    }

    self.setState({ _visit: visit });
  };

  _getTherapyOptions(data: any) {
    return (data && data.therapy) || [];
  }
  _getHomeMedicalOptions(data: any) {
    return (data && data.home_medical) || [];
  }
  _onTherapySelected = (_: any, therapy: string) => {
    const self = this,
      visit = self.state._visit;
    visit[home_rehabilitation] = therapy ? [therapy] : [];
    self._nurseRequiredChange(NURSE_REQUIREMENTS[0]); // nurse not required
    self._generateVisitCount();
  };
  _onMemoUpload = (files: UploadData[]) => {
    const self = this;
    const visit = self.state._visit;

    const therapyDetails = visit[therapy_details] || {};

    const displayUrls = files.map((f) => f.displayUrl);
    const s3Urls = files.map((f) => f.s3Url);
    const existingMemo = therapyDetails[doctor_memo] || [];
    const existingBlobs = therapyDetails[blob_urls] || [];

    therapyDetails[doctor_memo] = existingMemo.concat(s3Urls);
    therapyDetails[blob_urls] = existingBlobs.concat(displayUrls);

    visit[therapy_details] = therapyDetails;
    self.setState({ _visit: visit });
  };
  _onMemoDelete = (index: number) => {
    const self = this;
    const visit = self.state._visit;
    const therapyDetails = visit[therapy_details] || {};

    therapyDetails[doctor_memo]?.splice(index, 1);
    therapyDetails[blob_urls]?.splice(index, 1);
    therapyDetails[blob_urls] = therapyDetails[blob_urls]?.slice();

    self.setState({ _visit: visit });
  };
  _onMemoNotAvailable = () => {
    const self = this;
    const visit = self.state._visit;
    const therapyDetails = visit[therapy_details] || {};

    const have = therapyDetails[doctor_memo_available];
    therapyDetails[doctor_memo_available] = have === UNDEF ? false : !have;

    visit[therapy_details] = therapyDetails;
    self.setState({ _visit: visit });
  };

  _onExpectedOutcomeChange = (_e: any, outcome: string) => {
    const self = this;
    const visit = self.state._visit;
    const therapyDetails = visit[therapy_details] || {};
    therapyDetails[expected_outcome] = outcome;
    visit[therapy_details] = therapyDetails;
    self.setState({ _visit: visit });
  };

  _onHomeMedicalSelected = (_: any, hm: string) => {
    const self = this,
      visit = self.state._visit;
    visit[home_medical] = hm ? [hm] : [];
    visit[has_manual_transfer] = false;
    self._nurseRequiredChange(NURSE_REQUIREMENTS[0]); // nurse not required
  };

  // when nursing procedure is selected
  // set "nurse required"
  _updateNurseRequirements() {
    const self = this,
      visit = self.state._visit;
    const haveProcedures = !!(visit[nursing_procedure] || [])[0];
    const reason = visit[reason_for_nurse];
    const nursingProcSelected = "Nursing Procedures selected";
    const familyPreferNurse = "Family prefer a nurse";
    let newReason = "";

    if (haveProcedures) {
      visit[is_nurse_required] = true;
      if (visit[is_nurse_requested]) {
        visit[is_nurse_requested] = false;
      }
      if (reason === familyPreferNurse) {
        newReason = nursingProcSelected;
      } else {
        newReason = reason || nursingProcSelected;
      }
    } else if (visit[is_nurse_requested]) {
      newReason = reason || familyPreferNurse;
    }
    // no nursing procedures and nurse_required selected
    else if (visit[is_nurse_required]) {
      newReason = reason === nursingProcSelected ? "" : reason || "";
    }
    // nurse not required
    else {
      newReason = "";
    }

    visit[reason_for_nurse] = newReason;
    self.setState({ _visit: visit });
  }

  _nurseRequiredChange(text: string) {
    const self = this,
      visit = self.state._visit;
    let required: boolean | undefined, requested: boolean | undefined;

    const therapy = visit[home_rehabilitation];
    const homeMedical = visit[home_medical];
    if ((therapy && therapy[0]) || (homeMedical && homeMedical[0])) {
      required = false;
      requested = false;
    } else {
      if (text === NURSE_REQUIREMENTS[0]) {
        // not required
        required = false;
      } else if (text === NURSE_REQUIREMENTS[2]) {
        // nurse required
        required = true;
      } else if (text === NURSE_REQUIREMENTS[1]) {
        // nurse requested
        requested = true;
      }
    }

    visit[is_nurse_required] = required;
    visit[is_nurse_requested] = requested;
    visit[reason_for_nurse] = "";
    self._updateNurseRequirements();
  }

  // Get selected text value for the dropdown
  _getNurseRequirementText(isRequested?: boolean, isRequired?: boolean) {
    if (isRequested === UNDEF && isRequired === UNDEF) return "";
    if (!isRequested && !isRequired) return NURSE_REQUIREMENTS[0]; // not required
    return NURSE_REQUIREMENTS[isRequired ? 2 : 1]; // 2 = nurse required, 1 = nurse requested
  }

  // Therapy can only be selected as standalone option
  //  whenever there's adl, nursing procedures or home medical selected, disable the therapy
  _isTherapyDisabled(v?: any): boolean | undefined {
    const visit = v || this.state._visit;
    if (!visit) return;
    const haveAdl = (visit[requested_services] || [])[0];
    const haveProcedures = !!(visit[nursing_procedure] || [])[0];
    const haveHM = !!(visit[home_medical] || [])[0];
    return haveAdl || haveProcedures || haveHM;
  }

  // Home Medical can only be selected as standalone option
  //  whenever there's adl, nursing procedures or home medical selected, disable home medical
  _isHomeMedicalDisabled(v?: any): boolean | undefined {
    const visit = v || this.state._visit;
    if (!visit) return;
    const haveAdl = (visit[requested_services] || [])[0];
    const haveProcedures = !!(visit[nursing_procedure] || [])[0];
    const haveTherapy = !!(visit[home_rehabilitation] || [])[0];
    return haveAdl || haveProcedures || haveTherapy;
  }

  _dialogTitle(viewtype: VIEW_TYPE): string {
    const state = this.state;
    switch (viewtype) {
      case VIEW_TYPE.CUSTOM_REPEAT:
        return "Custom Recurrence";
      case VIEW_TYPE.ADDITIONAL_DETAILS:
        return "Additional Requirements";
      case VIEW_TYPE.UPDATE_VISIT:
        return "Update Visit" + state._updatingVisitsTitle;
      case VIEW_TYPE.CANCEL_VISIT:
        return "Cancel Visit";
      case VIEW_TYPE.PATIENT_DECLARATION:
        return "Patient Declaration";
      case VIEW_TYPE.MED_ESCORT_DETAILS:
        return "Medical Escort Details";
      case VIEW_TYPE.PREFERRED_CARE_PROS:
        return "Preferred CPs";
      default:
        return !state._isReadOnly
          ? "New Visit"
          : state._isUpdating
            ? "Update Visit" + state._updatingVisitsTitle
            : "Visit Details";
    }
  }

  // switch to default, custom recurrence, manual transfer views
  _switchView(viewtype = VIEW_TYPE.DEFAULT) {
    const self = this;
    const state = self.state;
    let repeatMode = state._repeatMode;
    let visitsCount = state._visitsCount;
    let updateVisitProps: UpdateVisitProps | any = {};
    let isUpdating = state._isUpdating;
    let visit = self.state._visit;
    const currentView = state._viewtype;

    (self._scrollerRef.current || {}).scrollTop = 0;

    if (viewtype === VIEW_TYPE.DEFAULT) {
      if (visitsCount === 0) {
        repeatMode = self._defaultRepeatMode();
        visitsCount = 1;
      }

      // Reset visit state to original state when back arrow clicked while editing a visit
      const views = [
        VIEW_TYPE.ADDITIONAL_DETAILS,
        VIEW_TYPE.PATIENT_DECLARATION,
        VIEW_TYPE.MED_ESCORT_DETAILS,
        VIEW_TYPE.PREFERRED_CARE_PROS
      ];

      if (isSG && currentView == VIEW_TYPE.ADDITIONAL_DETAILS) {
        this.setState({ _showErrors: '' });
      }

      if (currentView === VIEW_TYPE.PREFERRED_CARE_PROS) {
        // When Back button was pressed, reset form values on the subview
        this.setState({ current_selected_preferred_care_pros: visit.preferred_cps_list_by_service });
      }

      if (isUpdating && !views.includes(currentView)) {
        isUpdating = UNDEF;
        const visitJson = self._orgVisit;
        if (visitJson) {
          visit = JSON.parse(visitJson);
          const schedule = visit[visit_schedule];
          if (schedule) {
            visit.startDate = parseDate(schedule.date_from);
            visit.endDate = parseDate(schedule.date_to);
          }
        }
        this.setState({ _visit: visit });
      } else {
        // if back from medical escort details and no values selected, clear medical escort details
        // and remove "Medical Escort" from adl services
        const medEscDetails = visit[medical_escort_details];
        if (
          currentView === VIEW_TYPE.MED_ESCORT_DETAILS &&
          isObjEmpty(medEscDetails)
        ) {
          delete visit[medical_escort_details];
          const adls = visit[requested_services] || [];
          visit[requested_services] = adls.filter(
            (s: any) => s !== MEDICAL_ESCORT
          );
        }
      }
    } else if (
      viewtype === VIEW_TYPE.UPDATE_VISIT ||
      viewtype === VIEW_TYPE.CANCEL_VISIT
    ) {
      fixManualTransfer(visit);
      const crInfo = self.props.crInfo;
      const isVWO = !!(
        crInfo &&
        crInfo.client_type === "vwo" &&
        crInfo.vwo &&
        crInfo.vwo[0]
      );

      updateVisitProps = state._updateVisitProps || updateVisitProps;
      updateVisitProps["base_visit"] = visit;
      updateVisitProps[ADDED_VISITS] = [visit];
      updateVisitProps[INITIATED_BY] = isVWO ? "vwo" : "careowner";
      updateVisitProps[CUSTOMER_REQUEST_DATE] = toISOLocal(new Date());
    }

    self.setState({
      _visit: visit,
      _isUpdating: isUpdating,
      _viewtype: viewtype,
      _disableAnim: true,
      _repeatMode: repeatMode,
      _visitsCount: visitsCount,
      _updateVisitProps: updateVisitProps,
    });
    self._enableAnimations();
    return true;
  };

  _switchToDefaultView = () => {
    this._switchView();
  };

  _enableAnimations() {
    this.async(() => this.setState({ _disableAnim: false }), 300);
  }

  // Bottom right Apply button for custom date mode and additional requirements
  _onApply(viewtype?: VIEW_TYPE) {
    this._switchView();
  }

  _offsetCPCount(increment = true) {
    const self = this,
      visit = self.state._visit;
    const cps = (visit[required_cp] || 1) + (increment ? 1 : -1);
    visit[required_cp] = clamp(cps, 1, MAX_CPS_FOR_VISIT);
    self.setState({ _visit: visit });
  }

  _getDatesValidationError(visit: any): string | undefined {
    if (!visit || (this.state._isReadOnly && !this.state._isUpdating))
      return "";
    const startDate = visit.startDate,
      endDate = visit.endDate;

    if (!startDate || !endDate) return "Error";

    if (
      (isPastDate(startDate, true) || isPastDate(endDate, true)) &&
      !this._isFromDeeplink
    ) {
      return "Visit dates can't be in the past";
    }

    const isSpeechTherapy = (visit[home_rehabilitation] || []).includes(
      SPEECH_THERAPY
    );
    const duration = calculateDurationHourMinute(
      visit.startDate,
      visit.endDate
    );
    const durationHours = duration.hours + duration.minutes / 60;

    // don't allow values like 1.25 or 1.75  (1h 15m or 1h 45m etc..)
    const remainder = (durationHours * 100) % 100,
      min15 = remainder === 25,
      min45 = remainder === 75;
    if (!isSpeechTherapy && (min15 || min45)) {
      const hours = Math.floor(durationHours);
      const err = min15 ? `h or ${hours}.5h` : `.5h or ${hours + 1}h`;
      return `Invalid duration. Please change it to ${hours}${err}`;
    }

    const datesValid = isSpeechTherapy
      ? durationHours >= 0.5 // for speech therapy allow 30mins, 45mins
      : durationHours >= 1 && durationHours <= 24; // regular visits between 1hr to 24hr

    return datesValid
      ? ""
      : "For Speech Therapy, minimum 30 mins allowed. Regular visits must be between 1 and 24 hrs";
  }

  // is visit cancellable/editable
  _isEditable(visit: any) {
    return visit && (isFutureDate(visit.startDate) || this._isFromDeeplink);
  }

  _isCancellable(visit: any, status: string) {
    return (
      visit &&
      status !== "Cancelled" &&
      (isFutureDate(visit.startDate) || this._isFromDeeplink)
    );
  }

  // show errors when updating visit: for adl, nursing procedures, therapy, home medical, mobility
  _hasError(type: string) {
    const self = this,
      visit = self.state._visit,
      isUpdatingVisit = self.state._isUpdating;
    if (!visit) return;

    if (!isUpdatingVisit && type === customer_request_origin) {
      return !visit[customer_request_origin] ? "" : UNDEF;
    }

    // if location street_address and post_code not chosen show error
    if (!isUpdatingVisit && type === "location") {
      const isValidAddress =
        self.state._visit?.visit_location_address?.street_address &&
        self.state._visit?.visit_location_address?.post_code;
      return !isValidAddress ? "" : UNDEF;
    }

    if (!isUpdatingVisit) return;

    const adlMissing = !(visit[requested_services] || [])[0];
    const procMissing = !(visit[nursing_procedure] || [])[0];
    const therapyMissing = !(visit[home_rehabilitation] || [])[0];
    const homeMedicalMissing = !(visit[home_medical] || [])[0];

    if (type === "service") {
      return adlMissing && procMissing && therapyMissing && homeMedicalMissing
        ? ""
        : UNDEF;
    }

    if (type === "nurse") {
      const required = visit[is_nurse_required],
        requested = visit[is_nurse_requested];
      if (required === UNDEF && requested === UNDEF) return "";
      if (!(visit[reason_for_nurse] || "").trim() && (required || requested))
        return "";
      return;
    }

    return homeMedicalMissing && type === "mobility" && !visit[ambulant]
      ? ""
      : UNDEF;
  }

  _setPreferredCPsValuesInVisit = (careProList: Array<any>, _visit: any, key: string) => {
    const updatedVisit = { ..._visit, preferred_cps_list_by_service: { [key]: careProList } };
    return updatedVisit;
  }

  _removePreferredCPsValuesInVisit = (_visit: any) => {
    const visitClone = structuredClone(_visit);
    delete visitClone.preferred_cps_list_by_service;
    return visitClone;
  }

  _includePreferredCPsValuesInVisitIfConditionsAreMet = (visit: any) => {
    const { current_selected_preferred_care_pros } = this.state;
    const visitClone = structuredClone(visit)

    if (!visitClone?.preferred_cps) {
      // Preferred CP toggle is NO, so don't include Preferred Care Pros
      return this._removePreferredCPsValuesInVisit(visitClone);
    }

    const thereAreHomePersonalCareServicesSelected = visitClone?.requested_services?.length > 0 || visitClone?.nursing_procedure?.length > 0;
    const thereAreHomeTherapyServicesSelected = visitClone?.home_rehabilitation?.length > 0;
    const thereAreHomeMedicalServicesSelected = visitClone?.home_medical?.length > 0;

    if (thereAreHomePersonalCareServicesSelected) {
      const { home_personal_care } = current_selected_preferred_care_pros;
      return this._setPreferredCPsValuesInVisit(home_personal_care, visitClone, 'home_personal_care');
    }

    if (thereAreHomeTherapyServicesSelected) {
      const { home_therapy } = current_selected_preferred_care_pros;
      return this._setPreferredCPsValuesInVisit(home_therapy, visitClone, 'home_therapy');
    }
    if (thereAreHomeMedicalServicesSelected) {
      const { home_medical } = current_selected_preferred_care_pros;
      return this._setPreferredCPsValuesInVisit(home_medical, visitClone, 'home_medical');
    }

    // no services were selected, remove the key from the payload
    return this._removePreferredCPsValuesInVisit(visitClone);
  }

  _scrollToManualTransfer = () => {
    const self = this;
    const errElem: any = self._reqManualTransferRef.current;
    errElem && errElem.scrollIntoView();
  }

  _isRecipientMobilityCDEWithSpecificServicesforSingapore = (visit: any): boolean => {

    const isMobilityCDE = ['Level C', 'Level D', 'Level E'].indexOf(visit.ambulant) > -1;
    const selectedPersonalCare = visit.requested_services?.indexOf("Personal Care & Hygiene") > -1;
    const selectedToileting = visit.requested_services?.indexOf("Toileting") > -1;
    const selectedStayingActive = visit.requested_services?.indexOf("Staying Active") > -1;
    const selectedMedicalEscort = visit.requested_services?.indexOf("Medical Escort") > -1;
    const hasSpecificServices = selectedPersonalCare || selectedToileting || selectedStayingActive || selectedMedicalEscort;

    return isSG && isMobilityCDE && hasSpecificServices;
  }

  _checkIfManualTransferNeededBeforeProceeding = (visit: any): boolean => {

    const self = this;

    if (self._isRecipientMobilityCDEWithSpecificServicesforSingapore(visit)) {
      // 1. automatically select manual transfer 
      if (!visit.has_manual_transfer) {
        visit['has_manual_transfer'] = true;
        self.setState({ _showErrors: "mobility_cde_adl_error" });
        return true;
      }
      // 2. Invalidate the form if Transfer Help is YES but text is not filled in
      if (visit.manual_transfer_help == UNDEF || (visit.manual_transfer_help == true && !visit.manual_transfer_help_details)) {
        self.setState({ _showErrors: "mobility_cde_adl_error" });
        return true;
      }

      if (visit.manual_transfer_help == false) {
        visit[manual_transfer_help_details] = UNDEF;
      }
    }
    return false;
  };


  _copyTime(visit: any, propName: string, propValue: any) {
    let visitDateTime = parseDate(visit[visit_schedule][propName]);
    const updatedHours = parseDate(propValue).getHours();
    const updatedMins = parseDate(propValue).getMinutes();

    visitDateTime.setHours(updatedHours);
    visitDateTime.setMinutes(updatedMins);
    visit[visit_schedule][propName] = toISOLocal(visitDateTime);
  }

  // bottom right "Continue" btn actions
  _onContinueBtnClickUpdateVisit = (visit: any) => {

    const self = this,
      state = self.state,
      viewtype = state._viewtype;

    const viewtypeUpdateVisit = viewtype === VIEW_TYPE.UPDATE_VISIT;
    const viewtypeCancelVisit = viewtype === VIEW_TYPE.CANCEL_VISIT;
    const props = state._updateVisitProps;

    const updateVisitComp: any =
      (viewtypeUpdateVisit || viewtypeCancelVisit) &&
      self._updCancelCompRef.current;

    const updateCancelData =
      updateVisitComp && updateVisitComp.getRequestBody(props);

    if (!viewtypeUpdateVisit) {
      if (self._checkIfManualTransferNeededBeforeProceeding(visit)) {
        self._scrollToManualTransfer();
        return;
      };
      // Move to next dialog form for update visit
      self._switchView(VIEW_TYPE.UPDATE_VISIT);
    } else {
      updateCancelData.originalVisit = JSON.parse(self._orgVisit || "");
      // update visit schedules
      const baseVisit = updateCancelData[ADDED_VISITS][0];
      const visitSchedule: any = {};
      visitSchedule.date_from = toISOLocal(baseVisit.startDate);
      visitSchedule.date_to = toISOLocal(baseVisit.endDate);
      baseVisit[visit_schedule] = visitSchedule;

      const isPricingUpdate = (props || {})[IS_PRICING_UPDATE];
      const isFromDeeplink = (props || {})[IS_FROM_DEEPLINK];
      isPricingUpdate && (updateCancelData[IS_PRICING_UPDATE] = true);
      isFromDeeplink && (updateCancelData[IS_FROM_DEEPLINK] = true);

      const isDateFromUpdated = _.isEqual(
        updateCancelData.base_visit.visit_schedule.date_from,
        updateCancelData.originalVisit.visit_schedule.date_from
      );

      const isDateToUpdated = _.isEqual(
        updateCancelData.base_visit.visit_schedule.date_to,
        updateCancelData.originalVisit.visit_schedule.date_to
      );

      if (!isDateFromUpdated || !isDateToUpdated) {
        const visits = updateCancelData.visits;
        for (let k = visits.length; k--;) {
          this._copyTime(visits[k], 'date_from', updateCancelData.base_visit.visit_schedule.date_from);
          this._copyTime(visits[k], 'date_to', updateCancelData.base_visit.visit_schedule.date_to);
        }
      }

      const listViewCallback = self.props.moveToListView;
      self.close(true);
      listViewCallback && listViewCallback(UNDEF, updateCancelData);
    };
  };

  // bottom right "Cancel x Visit" btn actions
  _onCancelBtnClickCancelVisit = () => {
    const self = this,
      state = self.state,
      viewtype = state._viewtype;

    const viewtypeUpdateVisit = viewtype === VIEW_TYPE.UPDATE_VISIT;
    const viewtypeCancelVisit = viewtype === VIEW_TYPE.CANCEL_VISIT;

    const updateVisitComp: any =
      (viewtypeUpdateVisit || viewtypeCancelVisit) &&
      self._updCancelCompRef.current;

    const props = state._updateVisitProps;

    const updateCancelData =
      updateVisitComp && updateVisitComp.getRequestBody(props);

    updateCancelData &&
      Api.POST(API_CANCEL_VISITS, updateCancelData, (resp) => {
        if (resp) {
          self.close(true);

          const count = (props && props[ADDED_VISITS].length) || 1;
          const snackbarText = `${count} visit${count > 1 ? "s" : ""
            } cancelled successfully`;
          self.post(MSG_FETCH_VISITS, { message: snackbarText });
        }
      });
  };

  // bottom right "Done", "Apply", "Continue" btn actions
  _onDoneBtnClick = (visit: any) => {
    const self = this;
    const state = self.state;
    const viewtype = state._viewtype;
    const dialogtype = state._dialogtype;

    const viewtypeDefault = viewtype === VIEW_TYPE.DEFAULT;
    const viewtypeUpdateVisit = viewtype === VIEW_TYPE.UPDATE_VISIT;
    const viewtypeCancelVisit = viewtype === VIEW_TYPE.CANCEL_VISIT;
    const viewtypePreferredCPs = viewtype === VIEW_TYPE.PREFERRED_CARE_PROS;
    //const viewtypeAddDetails  = viewtype === VIEW_TYPE.ADDITIONAL_DETAILS;
    const dialogtypeAddReq = dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS;
    const dialogtypeMedEscort = dialogtype === DIALOG_TYPE.MEDICAL_ESCORT_DETAILS;
    const dialogtypePatientDecl = dialogtype === DIALOG_TYPE.PATIENT_DECLARATION;
    const dialogtypePreferredCP = dialogtype === DIALOG_TYPE.PREFERRED_CARE_PROS;

    // Cancel visit(s)
    if (viewtypeCancelVisit) {
      self._onCancelBtnClickCancelVisit();
    }
    // Updating existing visit(s)
    else if (state._isUpdating && (viewtypeDefault || viewtypeUpdateVisit)) {
      self._onContinueBtnClickUpdateVisit(visit);
    }
    else if (viewtypePreferredCPs) {
      const { _visit, current_selected_preferred_care_pros } = state;

      self.setState({
        _visit: { ..._visit, preferred_cps_list_by_service: current_selected_preferred_care_pros }
      },
        () => {
          if (dialogtypePreferredCP) {
            // in val listview, returns to listview
            self.close(false);
          } else {
            // switch back to default view after changing visit data in create visit
            self._onApply();
          }
        }
      );
    }
    // Creating new visit, or Selecting additional requirements, medical escort details, patient declaration etc.
    else if (
      viewtypeDefault ||
      dialogtypeAddReq ||
      dialogtypeMedEscort ||
      dialogtypePatientDecl ||
      dialogtypePreferredCP
    ) {

      if (self._checkIfManualTransferNeededBeforeProceeding(visit)) {
        self._scrollToManualTransfer();
        return;
      };

      // validation for customer request source
      if (viewtypeDefault && self._hasError(customer_request_origin) === "") {
        const errElem: any = self._reqOriginRef.current;
        errElem && errElem.scrollIntoView();
        self.setState({ _showErrors: customer_request_origin });
        return;
      };

      // validation for location address
      if (
        (isAU || isMY) &&
        viewtypeDefault &&
        self._hasError("location") === ""
      ) {
        const errElem: any = self._reqLocationRef.current;
        errElem && errElem.scrollIntoView();
        self.setState({ _showErrors: "location" });
        return;
      }

      //TODO: add validation for med escort and patient declaration

      self.close(false);
    }
    // Apply custom recurrence settings
    else {
      self._onApply(viewtype);
    }
  };

  _doneBtnText(isUpdating: boolean, viewtype: VIEW_TYPE) {
    const isAdditionalReqDlg = viewtype === VIEW_TYPE.ADDITIONAL_DETAILS;
    const isMedEscortDlg = viewtype === VIEW_TYPE.MED_ESCORT_DETAILS;
    const isPatientDeclDlg = viewtype === VIEW_TYPE.PATIENT_DECLARATION;
    const isPreferredCPDlg = viewtype === VIEW_TYPE.PREFERRED_CARE_PROS;
    const isSubDialog =
      isAdditionalReqDlg || isMedEscortDlg || isPatientDeclDlg || isPreferredCPDlg;

    if (isUpdating && !isSubDialog) {
      return "Continue";
    } else if (viewtype === VIEW_TYPE.DEFAULT) {
      return "Done";
    } else if (viewtype === VIEW_TYPE.CANCEL_VISIT) {
      const props = this.state._updateVisitProps;
      const count = (props && props[ADDED_VISITS].length) || 1;
      return `Cancel ${count} Visit${count > 1 ? "s" : ""}`;
    } else if (this._isUpdate) {
      return "Apply to all visits";
    } else {
      return "Apply";
    }
  };
  _doneBtnDisabled(
    visit: any,
    isUpdating: boolean,
    visitCount: number,
    viewtype: VIEW_TYPE,
    dialogtype: DIALOG_TYPE
  ) {
    const self = this;
    if (
      dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS &&
      visit[have_hoist] === false &&
      visit[manual_transfer_help] === false &&
      !visit[co_accept_2_cps]
    )
      return true;
    if (
      viewtype === VIEW_TYPE.CANCEL_VISIT ||
      viewtype === VIEW_TYPE.UPDATE_VISIT
    ) {
      const component = self._updCancelCompRef.current;
      return !component || !component.validate(self.state._updateVisitProps);
    }

    // Updating a visit but no change has been made or some errors exist
    // keep the button disabled
    if (isUpdating) {
      return (
        self._hasError("nurse") === "" || ////self._orgVisit === JSON.stringify(self.state._visit) ||
        self._hasError("service") === "" ||
        self._hasError("mobility") === "" ||
        !!self._getDatesValidationError(visit)
      );
    }

    return (
      visitCount === 0 &&
      dialogtype !== DIALOG_TYPE.ADDITIONAL_REQUIREMENTS &&
      dialogtype !== DIALOG_TYPE.MEDICAL_ESCORT_DETAILS &&
      dialogtype !== DIALOG_TYPE.PATIENT_DECLARATION
    );
  }

  _getEstimatedFees(paymentBreakdown: any, careownerPenalties: any) {
    if (!paymentBreakdown) return "";

    const penalties = (careownerPenalties || []).reduce((base: any, v: any) => {
      if (!v.waived) {
        base += parseFloat(v.fee);

        if (v.gst_amount) {
          base += parseFloat(v.gst_amount);
        }
      } else base += 0;

      return base;
    }, 0);

    const fees: FeeType[] = [
      parseFeeValue(paymentBreakdown.total_fee),
      parseFeeValue(paymentBreakdown.additional_amount),
      parseFeeValue(paymentBreakdown.gst_on_visit),
      parseFeeValue(penalties.toString()),
    ];

    return parseFees(fees);
  }

  _showGSTText(paymentBreakdown: any) {
    if (toNum(paymentBreakdown.gst_on_visit) > 0) return "(incl. GST)";
    return "";
  }

  _updateCustReqTime(militaryTime?: string, customerReqDateString?: string) {
    if (!militaryTime || !customerReqDateString) return;

    const arr = militaryTime.split(":");
    const hours = parseInt(arr[0]);
    const minutes = parseInt(arr[1]);
    if (hours >= 0 && minutes >= 0) {
      const date = parseDate(customerReqDateString);
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      this._onPropChange(customer_requested_at, toISOLocal(date));
    }
  }

  _toggle = (visit: any, e: any, prop: string, isSelected?: boolean) => {
    visit[prop] =
      isSelected === true || isSelected === false ? isSelected : !visit[prop];
    e && e.detail === 1 && e.currentTarget.blur(); //blur when left mouse click

    if (
      visit[have_hoist] === false &&
      visit[manual_transfer_help] === false &&
      Number(visit[required_cp]) < 2
    ) {
      visit[required_cp] = 2;
    }
    this.setState({ _visit: visit });
  };

  _changeTextHeight = (e: any) => {
    e._refInput.current.style.height = "auto";
    e._refInput.current.style.height = e._refInput.current.scrollHeight + "px";
  };

  //Reset the textbox height
  _setInitialTextHeight = () => {
    const elements = document.getElementsByClassName(
      "nvd-special-instructions nvd-ops-inst"
    );
    Array.from(elements).forEach((element) => {
      const textarea = element.getElementsByTagName("textarea")[0];
      if (textarea) {
        textarea.style.height = "auto";
      }
    });
  };

  _renderAutoAssignToggle = () => {
    const self = this,
      state = self.state,
      props = self.props;

    const { _isReadOnly, _isUpdating, _visit } = state;
    const { is_b2b_auto_assignment_enabled, is_b2c_auto_assignment_enabled } = props.data;

    const isReadOnly = _isReadOnly && !_isUpdating;
    const visit = _visit || {};

    if (isAppTypeB2B && is_b2b_auto_assignment_enabled) {
      return <AutoAssignToggle
        isReadOnly={isReadOnly}
        toggleValueForReadOnly={visit[preferred_cps]}
        toggleValueForActiveForm={visit[preferred_cps]}
        onClick={self._onPreferredCpsSelect}
      />
    }

    if (isAppTypeB2C && is_b2c_auto_assignment_enabled) {
      return <AutoAssignToggle
        isReadOnly={isReadOnly}
        toggleValueForReadOnly={visit[preferred_cps]}
        toggleValueForActiveForm={visit[preferred_cps]}
        onClick={self._onPreferredCpsSelect}
      />
    }

    return null;
  }

  render() {
    const self = this,
      state = self.state,
      props = self.props;
    const prevVisit = props.previousVisit;
    const viewtype = state._viewtype,
      dialogtype = state._dialogtype;

    const viewtypeDefault = viewtype === VIEW_TYPE.DEFAULT;
    const viewtypeAdditionalDetails = viewtype === VIEW_TYPE.ADDITIONAL_DETAILS;
    const viewtypeCustomRepeat = viewtype === VIEW_TYPE.CUSTOM_REPEAT;
    const viewtypeUpdateVisit = viewtype === VIEW_TYPE.UPDATE_VISIT;
    const viewtypeCancelVisit = viewtype === VIEW_TYPE.CANCEL_VISIT;
    const viewtypePatientDecl = viewtype === VIEW_TYPE.PATIENT_DECLARATION;
    const viewtypeMedEscort = viewtype === VIEW_TYPE.MED_ESCORT_DETAILS;
    const viewtypePreferredCarePros = viewtype === VIEW_TYPE.PREFERRED_CARE_PROS;

    //const dialogtypeNewVisit        = dialogtype === DIALOG_TYPE.NEW_VISIT;
    const dialogtypeVisitDetails = dialogtype === DIALOG_TYPE.VISIT_DETAILS;
    const dialogtypeAddReq = dialogtype === DIALOG_TYPE.ADDITIONAL_REQUIREMENTS;
    const dialogtypeMedEscort =
      dialogtype === DIALOG_TYPE.MEDICAL_ESCORT_DETAILS;
    const dialogtypePatientDecl =
      dialogtype === DIALOG_TYPE.PATIENT_DECLARATION;
    const dialogtypePreferredCP = dialogtype === DIALOG_TYPE.PREFERRED_CARE_PROS;
    const isSubDialog =
      dialogtypeAddReq || dialogtypeMedEscort || dialogtypePatientDecl || dialogtypePreferredCP;

    const visit = state._visit || {};

    const isUpdating = !!state._isUpdating;
    const isReadOnly = state._isReadOnly && !isUpdating;
    const goneIfReadOnly = isReadOnly ? " gone" : "";

    const selectedAdls = visit[requested_services] || [];
    const selectedProcedures = visit[nursing_procedure] || [];
    const homeMedicalDetails = visit[home_medical_details] || {};
    const selectedHomeMedProcedures = homeMedicalDetails[procedures] || [];
    const isHomeMedDisabled = self._isHomeMedicalDisabled();
    const homeMedValue = (visit[home_medical] || [])[0];

    const haveManualTransfer = visit[has_manual_transfer];
    const haveManualTransferHelp = visit[manual_transfer_help];
    const haveAdditionalRequirements =
      haveManualTransfer || visit[require_vital_sign];

    const repeatMode = state._repeatMode;

    const fulfillmentNote = visit[internal_ops_fulfillment_note];
    const opsCRNote = visit[internal_ops_cr_note];
    const haveInternalNotes = !!(fulfillmentNote || opsCRNote);

    const assignedCarepros = visit[assigned_carepros] || [];
    if (!assignedCarepros.length) assignedCarepros.push({});
    let minCPs = assignedCarepros.length;
    const haveHoist = visit[have_hoist];

    //for AU-> when no hoist and addl. help available
    if (isAU && haveHoist === false && haveManualTransferHelp === false) {
      minCPs = Math.max(2, minCPs);
    }

    const paymentBreakdown = visit[payment_breakdown];

    const customerReqSrc = visit[customer_request_origin];
    const customerReqSrcDisabled = VISIT_SOURCE_DISABLED.includes(
      customerReqSrc || ""
    );
    const custReqDateString = visit[customer_requested_at];

    const custReqDate = custReqDateString && convertToDestTZ(
      parseDate(custReqDateString),
      this.props.region
    );
    const custReqTime =
      custReqDate &&
      minsToMilitary(custReqDate.getHours() * 60 + custReqDate.getMinutes());

    if (isObjEmpty(visit)) return null;

    const therapyDisabled = self._isTherapyDisabled();
    const therapytype = (visit[home_rehabilitation] || [])[0];
    const havePatientDecl = havePatientDeclaration(visit);
    const therapyDetails = visit[therapy_details] || {};

    const visitStatus = visit.status && visit.status.visit;

    if (!Object.hasOwn(visit, visit_location_address)) {
      // It can take a moment for setState to load the data from onMessage
      // During this time we display nothing to prevent errors (would be better to show a loader)
      return null;
    };

    return (
      <div
        className="nvd-root"
        onClick={() => self._showConfirmation()}
        attr-visible={self.state.open ? "true" : UNDEF}
      >
        <div
          className="nvd ha-dialog v"
          ref={self._innerDialogRef}
          attr-visible={self.state._open ? "true" : UNDEF}
          is-visit-details={_attr(isReadOnly && viewtypeDefault)}
          onClick={self.eatClick}
        >
          <div className="h justified center nvd-cursor-normal no-shrink">
            <div className="nvd-title h center">
              <IconButton
                aria-label="back"
                onClick={self._switchToDefaultView}
                className={`nvd-back ${!isUpdating && (viewtypeDefault || isSubDialog) ? "gone" : ""
                  }`}
                size="small"
              >
                <ArrowBack />
              </IconButton>
              <span>{self._dialogTitle(viewtype)}</span>

              {visit &&
                !isSubDialog &&
                !viewtypeCancelVisit &&
                !isUpdating &&
                visitStatus && (
                  <span
                    className={`nvd-status nvd-${visitStatus.replace(" ", "")}`}
                  >
                    {visitStatus}
                  </span>
                )}
            </div>

            <div className="h">
              {!isUpdating &&
                !viewtypeCancelVisit &&
                dialogtypeVisitDetails &&
                self._isEditable(visit) && (
                  <IconButton
                    aria-label="Update Visit"
                    onClick={() =>
                      self.setState({ _isUpdating: true, _disableAnim: true })
                    }
                    className="nvd-close"
                    size="small"
                  >
                    <img src="/edit_dark.png" alt="" width="17" />
                  </IconButton>
                )}

              {!isUpdating &&
                !viewtypeCancelVisit &&
                dialogtypeVisitDetails &&
                self._isCancellable(visit, visitStatus) && (
                  <IconButton
                    aria-label="Cancel Visit"
                    onClick={() => self._switchView(VIEW_TYPE.CANCEL_VISIT)}
                    className="nvd-close"
                    size="small"
                  >
                    <img src="/delete_dark.png" alt="" width="17" />
                  </IconButton>
                )}

              <IconButton
                aria-label="close"
                onClick={() => self._showConfirmation()}
                className="nvd-close"
                size="small"
              >
                <Close />
              </IconButton>
            </div>
          </div>
          <div className="nvd-line" />

          <div
            ref={self._scrollerRef}
            className="nvd-pc sbar"
            selected-index={viewtype}
          >
            {/* Default view */}
            <div
              className="nvd-view-type-default"
              data-visible={_attr(viewtypeDefault)}
            >
              <Div
                className="nvd-row h center"
                has-error={self._getDatesValidationError(visit) ? "" : UNDEF}
                maxH={43}
              >
                <Img src="/visit_history.png" className="nvd-icon" />
                <Div ml={-8} />
                <DateTimeDisplay
                  className="nvd-dtd"
                  region={this.props.region}
                  readOnly={isReadOnly}
                  updating={isUpdating}
                  dontAnimate={state._disableAnim}
                  startDate={visit.startDate}
                  endDate={visit.endDate}
                  dontAllowPastDates
                  boldToday
                  onChange={self._onDatesChange}
                />

                <span className="nvd-error nvd-flex-top">
                  <img
                    alt="error"
                    src="/warning_red.png"
                    className="nvd-error-icon"
                  />
                  {self._getDatesValidationError(visit)}
                </span>
              </Div>
              {!isReadOnly && !isUpdating && (
                <div className="nvd-row h center nvd-repeat-mode">
                  <Img src="/repeat.png" className="nvd-icon" />
                  <Div ml={-8} />
                  <TextDropdown
                    dontAnimate={state._disableAnim}
                    items={state._repeatModes}
                    selectedItem={self._getRepeatModeText(repeatMode)}
                    onChange={(_: any, selectedItem: string) =>
                      self._repeatModeChange(selectedItem)
                    }
                  />
                </div>
              )}
              <Div
                className="h"
                margin="8px 0px"
                has-error={self._hasError("location")}
              >
                <Img src="/location.png" className="nvd-icon" />
                <Div ml={-8} vref={self._reqLocationRef} />

                {!isReadOnly ? (
                  <LocationDropdown
                    // @ts-ignore
                    hasError={state._showErrors === "location"}
                    location={visit[visit_location_address]}
                    onChange={(v: VisitLocationAddress) =>
                      self._locationChange(v)
                    }
                  />
                ) : (
                  <LocationInput
                    ref={self._locRef}
                    readOnly={isReadOnly}
                    location={visit[visit_location_address]}
                    states={props.states}
                    // locationFields={props.locationFields}
                    onChange={(v: VisitLocationAddress) =>
                      self._locationChange(v)
                    }
                  />
                )}

                {/* {state._showErrors && (
                  <div className="nvd-error nvd-err-long">
                    <img
                      alt="error"
                      src="/warning_red.png"
                      className="nvd-error-icon"
                    />
                    Address is not correct
                  </div>
                )} */}
              </Div>
              <ADLServicesSection
                selectedAdls={selectedAdls}
                goneIfReadOnly={goneIfReadOnly}
                hasError={self._hasError("service")}
                adlList={self._getAdlList(props.data)}
                mealRequirements={visit[meal_requirements]}
                isReadOnly={isReadOnly}
                dontAnimate={state._disableAnim}
                onAdlChange={self._onAdlChange}
                onTextChange={(_e: any, t: string) => self._onPropChange(companionship_description, t)}
                companionShipDescription={visit[companionship_description]}
                switchViewToMedicalEscortDetails={() => self._switchView(VIEW_TYPE.MED_ESCORT_DETAILS)}
                medicalEscortDetails={getMedicalEscortDetails(visit, this.props.region)}
                visitHasMedicalEscortDetails={visit[medical_escort_details]}
              />
              <NursingProceduresSection
                hasError={self._hasError("service")}
                goneIfReadOnly={goneIfReadOnly}
                selectedProcedures={selectedProcedures}
                dontAnimate={state._disableAnim}
                isReadOnly={isReadOnly}
                onProceduresChange={self._onProceduresChange}
                availableProcedures={props.data && props.data.available_procedures}
              />
              <div
                className="nvd-row h nvd-nurse-dropdown"
                has-error={self._hasError("nurse")}
              >
                <Img src="/nurse.png" className="nvd-icon" />
                <i className="nvd-star">*</i>

                <Div w100 flexStart className="v nvd-service">
                  <Txt
                    className="nvd-error nvd-err-long"
                    mh={0}
                    mv={0}
                    absL={200}
                    absT={8}
                  >
                    <img
                      alt="error"
                      src="/warning_red.png"
                      className="nvd-error-icon"
                    />
                    Please select nurse requirement and reason
                  </Txt>

                  <TextDropdown
                    items={NURSE_REQUIREMENTS}
                    placeholder="Nurse requirements"
                    dontAnimate={state._disableAnim}
                    disabled={!!selectedProcedures[0]}
                    readOnly={isReadOnly}
                    popupDisabled={isReadOnly}
                    selectedItem={self._getNurseRequirementText(
                      visit[is_nurse_requested],
                      visit[is_nurse_required]
                    )}
                    onChange={(_: any, selectedItem: string) =>
                      self._nurseRequiredChange(selectedItem)
                    }
                  />

                  <Div height={1} />

                  <InputField
                    type="text"
                    className="nvd-specific-instructions"
                    width="100%"
                    maxWidth="100%"
                    dontAnimate={state._disableAnim}
                    noAutoSelect
                    lineHeight={16}
                    blurOnTabKey
                    placeholder="Reason"
                    readOnly={isReadOnly}
                    hidden={
                      !visit[is_nurse_required] && !visit[is_nurse_requested]
                    }
                    onTextChange={(_e: any, t: string) =>
                      self._onPropChange(reason_for_nurse, t)
                    }
                    text={visit[reason_for_nurse]}
                  />
                </Div>
              </div>
              {(!isReadOnly || !therapyDisabled) && (
                <>
                  <div
                    className="nvd-row h nvd-therapy-dropdown"
                    has-error={self._hasError("service")}
                  >
                    <Img src="/physiotherapy.png" className="nvd-icon" />

                    <div>
                      <Txt
                        className="nvd-error nvd-err-long"
                        mh={0}
                        mv={0}
                        absL={200}
                        absT={8}
                      >
                        <img
                          alt="error"
                          src="/warning_red.png"
                          className="nvd-error-icon"
                        />
                        Please select some services
                      </Txt>
                      <TextDropdown
                        className="nvd-service"
                        dropdownColor={c4A4A4A}
                        placeholder="Home Therapy"
                        selectedItem={therapytype}
                        dontAnimate={state._disableAnim}
                        hidden={therapyDisabled}
                        readOnly={isReadOnly}
                        popupDisabled={isReadOnly}
                        items={self._getTherapyOptions(props.data)}
                        onChange={self._onTherapySelected}
                      />
                    </div>
                    <div
                      className={`nvd-therapy-disabled h center ${!therapyDisabled ? "gone" : ""
                        }`}
                    >
                      Select Therapy as a standalone service
                    </div>
                  </div>

                  {/* Show doctor memo section for physiotherapy and speech therapy */}
                  {!therapyDisabled &&
                    (therapytype === PHYSIOTHERAPY ||
                      therapytype === SPEECH_THERAPY) && (
                      <DoctorsMemo
                        coId={props.coId || props.vwoId || ""}
                        displayUrls={therapyDetails[blob_urls] || []}
                        memoAvailable={therapyDetails[doctor_memo_available]}
                        onUploadSuccess={self._onMemoUpload}
                        onDelete={self._onMemoDelete}
                        onNotAvailable={self._onMemoNotAvailable}
                        readOnly={isReadOnly}
                        mt={3}
                        ml={46}
                        mb={7}
                      />
                    )}

                  {!therapyDisabled && therapytype === OCCUPATIONAL_THERAPY && (
                    <Div ml={38} pb={7}>
                      <InputField
                        type="text"
                        className="nvd-specific-instructions"
                        width="100%"
                        maxWidth="100%"
                        dontAnimate={state._disableAnim}
                        multiLine
                        noAutoSelect
                        lineHeight={16}
                        maxLines={6}
                        blurOnTabKey
                        placeholder="What is the Care Owner's expected outcome?"
                        readOnly={isReadOnly}
                        onTextChange={self._onExpectedOutcomeChange}
                        text={therapyDetails[expected_outcome]}
                      />
                    </Div>
                  )}
                </>
              )}
              {(!isReadOnly || !isHomeMedDisabled) && (
                <>
                  <div
                    className="nvd-row h nvd-nurse-dropdown"
                    has-error={self._hasError("service")}
                  >
                    <Img src="/home_medical.png" className="nvd-icon" />

                    <div>
                      <Txt
                        className="nvd-error nvd-err-long"
                        mh={0}
                        mv={0}
                        absL={200}
                        absT={8}
                      >
                        <img
                          alt="error"
                          src="/warning_red.png"
                          className="nvd-error-icon"
                        />
                        Please select some services
                      </Txt>
                      <TextDropdown
                        className="nvd-service"
                        dropdownColor={c4A4A4A}
                        placeholder="Home Medical"
                        selectedItem={homeMedValue}
                        dontAnimate={state._disableAnim}
                        hidden={isHomeMedDisabled}
                        readOnly={isReadOnly}
                        popupDisabled={isReadOnly}
                        items={self._getHomeMedicalOptions(props.data)}
                        onChange={self._onHomeMedicalSelected}
                      />
                    </div>
                    <div
                      className={`nvd-therapy-disabled h center ${!isHomeMedDisabled ? "gone" : ""
                        }`}
                    >
                      Select Home Medical as a standalone service
                    </div>
                  </div>

                  {/* Home medical procedures dropdown  */}
                  {!isHomeMedDisabled && homeMedValue === BASIC_CONSULTATION && (
                    <>
                      <div
                        className={`nvd-row h${!selectedHomeMedProcedures[0] ? goneIfReadOnly : ""
                          }`}
                      >
                        <Img
                          src="/self-serve/medical-procedure@3x.png"
                          className="nvd-icon"
                          mt={-1}
                        />

                        {/* Medical procedures */}
                        <div className="h grow">
                          <Div
                            className="nvd-text no-shrink"
                            width={86 + 23 + 18}
                          >
                            <Txt pt={2}>Medical Procedures</Txt>
                          </Div>

                          <NursingProcedures
                            className="nvd-cont nvd-w100"
                            tdClassName="nvd-service"
                            tdInputClassName="nvd-proc-input"
                            homeMedical
                            placeholder="Select medical procedures"
                            available_procedures={
                              props.data && props.data.home_medical_procedures
                            }
                            selectedProcedures={selectedHomeMedProcedures}
                            dontAnimate={state._disableAnim}
                            readOnly={isReadOnly}
                            onProceduresChange={self._onHomeMedProceduresChange}
                          />
                        </div>
                      </div>

                      <div
                        className={`nvd-row h${!havePatientDecl ? goneIfReadOnly : ""
                          }`}
                      >
                        <Img
                          src="/self-serve/patient-dec@3x.png"
                          className="nvd-icon"
                        />
                        <button
                          className={`h nvd-add-req ${havePatientDecl ? "grow" : ""
                            }`}
                          onClick={(e: any) =>
                            (!isReadOnly &&
                              self._switchView(
                                VIEW_TYPE.PATIENT_DECLARATION
                              )) ||
                            e.currentTarget.blur()
                          }
                        >
                          <Div
                            className="nvd-text no-shrink"
                            width={havePatientDecl ? 86 + 23 + 18 : ""}
                          >
                            <span>Patient Declaration</span>
                          </Div>

                          <PatientDeclarationDisplay
                            visit={visit}
                            className="nvd-cont v"
                          />
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
              <div
                className="nvd-row nvd-mobility-types h"
                has-error={self._hasError("mobility")}
              >
                <Img src="/mobility_blue.png" className="nvd-icon" />
                <i className="nvd-star">*</i>
                <Div ml={-8} />

                <Div v w100 flexStart>
                  <Txt
                    className="nvd-error nvd-err-long"
                    mh={0}
                    mv={0}
                    absL={200}
                    absT={8}
                  >
                    <img
                      alt="error"
                      src="/warning_red.png"
                      className="nvd-error-icon"
                    />
                    Please select senior's mobility
                  </Txt>
                  <TextDropdown
                    items={MOBILITY_TYPES}
                    selectedItem={MOBILITY_TYPES.find(
                      (type: string) =>
                        visit[ambulant] &&
                        type.startsWith(visit[ambulant] || "")
                    )}
                    dontAnimate={state._disableAnim}
                    placeholder="Mobility Level"
                    readOnly={isReadOnly}
                    popupDisabled={isReadOnly}
                    onChange={(comp: any, selectedItem: string) =>
                      self._mobilitytypeChange(comp, selectedItem)
                    }
                  />
                  <Div height={1} />

                  <InputField
                    hidden={!visit[ambulant]}
                    type="text"
                    className="nvd-specific-instructions"
                    width="100%"
                    maxWidth="100%"
                    multiLine
                    noAutoSelect
                    lineHeight={16}
                    maxLines={3}
                    dontAnimate={state._disableAnim}
                    readOnly={isReadOnly}
                    blurOnTabKey
                    placeholder="Are there any specific mobility instructions?"
                    onTextChange={(_e: any, t: string) =>
                      self._onPropChange(mobility_instruction, t)
                    }
                    text={visit[mobility_instruction]}
                  />
                </Div>
              </div>
              <div
                className={`nvd-row h${!haveAdditionalRequirements ? goneIfReadOnly : ""
                  }`}
              >
                <Img src="/mt-blue.png" className="nvd-icon" />
                <button
                  className={`h nvd-add-req ${haveAdditionalRequirements ? "grow" : ""
                    }`}
                  onClick={(e: any) =>
                    (!isReadOnly &&
                      self._switchView(VIEW_TYPE.ADDITIONAL_DETAILS)) ||
                    e.currentTarget.blur()
                  }
                >
                  <Div
                    className="nvd-text no-shrink"
                    width={haveAdditionalRequirements ? 127 : ""}
                  >
                    <span>Additional Requirements</span>
                  </Div>
                  <Div ml={-8} vref={self._reqManualTransferRef} />
                  <AdditionalRequirementsInfo visit={visit} />
                  {isSG && state._showErrors === 'mobility_cde_adl_error' && (
                    <span className="moblity-cde-error moblity-cde-err-long">
                      <img
                        alt="error"
                        src="/warning_red.png"
                        className="mobility-cde-error-icon"
                      />
                      &nbsp;Please provide additional details
                    </span>
                  )}
                </button>
              </div>
              <div>

              </div>
              <div
                className={`nvd-row h${!visit[special_requests_instructions] ? goneIfReadOnly : ""
                  }`}
              >
                <Img src="/instructions.png" className="nvd-icon" />
                <Div ml={-8} />
                <InputField
                  type="text"
                  className="nvd-text nvd-special-instructions"
                  width="100%"
                  maxWidth="100%"
                  readOnly={isReadOnly}
                  lineHeight={22}
                  maxLines={5}
                  multiLine
                  noAutoSelect
                  blurOnTabKey
                  dontAnimate={state._disableAnim}
                  placeholder="Special Instructions"
                  onTextChange={(_e: any, t: string) =>
                    self._onPropChange(special_requests_instructions, t)
                  }
                  text={visit[special_requests_instructions]}
                />
              </div>
              <NumberOfCareProsRequired
                isReadOnly={isReadOnly}
                minusDisabled={(visit[required_cp] || minCPs) <= minCPs}
                plusDisabled={(visit[required_cp] || 1) >= MAX_CPS_FOR_VISIT}
                numberOfCarePros={visit[required_cp]}
                onClickMinus={(e: any) => blur(e) && self._offsetCPCount(false)}
                onClickPlus={(e: any) => blur(e) && self._offsetCPCount(true)}
              />
              <SelectedCarePros
                isReadOnly={isReadOnly}
                assignedCarepros={assignedCarepros}
              />
              {self._renderAutoAssignToggle()}
              <div className="nvd-subcontent">
                <SelectPreferredCarePros
                  onClickButton={() => self._switchView(VIEW_TYPE.PREFERRED_CARE_PROS)}
                  showSelectPreferredCarePros={visit[preferred_cps]}
                  careProsList={visit[preferred_cps_list_by_service]}
                  thereAreHomePersonalCareServicesSelected={visit?.requested_services?.length > 0 || visit?.nursing_procedure?.length > 0}
                  thereAreHomeTherapyServicesSelected={visit?.home_rehabilitation?.length > 0}
                  thereAreHomeMedicalServicesSelected={visit?.home_medical?.length > 0}
                  isReadOnlyMode={isReadOnly}
                />
                <HardSoftPreferenceForVisitDialogue
                  value={visit[preferred_cps_option]}
                  visitClone={structuredClone(self.state._visit)}
                  onRadioButtonChange={(updatedVisit) => self.setState({ _visit: { ...updatedVisit } })}
                  onInitialLoad={(updatedVisit) => self.setState({ _visit: { ...updatedVisit } })}
                  careProsList={visit[preferred_cps_list_by_service]}
                  showSelectPreferredCarePros={visit[preferred_cps]}
                  thereAreHomePersonalCareServicesSelected={visit?.requested_services?.length > 0 || visit?.nursing_procedure?.length > 0}
                  thereAreHomeTherapyServicesSelected={visit?.home_rehabilitation?.length > 0}
                  thereAreHomeMedicalServicesSelected={visit?.home_medical?.length > 0}
                  isReadOnlyMode={isReadOnly}
                />
              </div>
              {props.crInfo.has_breaks && (
                <div className="nvd-row h center nvd-repeat-mode">
                  <Img src="/visit_breaks.png" mt={-6} className="nvd-icon" />
                  <Div ml={-8} />
                  <TextDropdown
                    readOnly={isReadOnly}
                    popupDisabled={isReadOnly}
                    dontAnimate={state._disableAnim}
                    items={VISIT_BREAK_OPTIONS}
                    selectedItem={self._visitBreakText(visit[breaks])}
                    onChange={(_: any, selectedItem: string) =>
                      self._visitBreakChange(selectedItem)
                    }
                  />
                </div>
              )}
              {!isReadOnly &&
                !isUpdating &&
                prevVisit &&
                prevVisit.adl_pricing_packages && (
                  <div className="nvd-row h">
                    <Img src="/pricing.png" className="nvd-icon" />
                    <div className="h grow">
                      <Txt className="nvd-text no-shrink" width={100}>
                        Previously used pricing items
                      </Txt>
                      <div className="nvd-cont v">
                        <div className="h wrap">
                          {prevVisit.adl_pricing_packages
                            .concat(prevVisit.procedure_pricing_packages || [])
                            .map((item: any) => {
                              return (
                                <div
                                  className="chip chip-gray-border"
                                  key={item._id}
                                >
                                  {item.name}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {isReadOnly && visit.adl_pricing_packages && (
                <div className="nvd-row h">
                  <Img src="/pricing.png" className="nvd-icon" />
                  <div className="h grow">
                    <Txt className="nvd-text no-shrink" width={100} mr={-10}>
                      Applied pricing items
                    </Txt>
                    <div className="nvd-cont v">
                      <div className="h wrap">
                        {visit.adl_pricing_packages
                          .concat(visit.procedure_pricing_packages || [])
                          .map((item: any, index: number) => {
                            return (
                              <div className="chip chip-big" key={index}>
                                {item.name}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <Div
                className={`nvd-line${!haveInternalNotes ? goneIfReadOnly : ""
                  }`}
                mh={0}
                mv={10}
              />
              <div
                className={`nvd-row h${!haveInternalNotes ? goneIfReadOnly : ""
                  }`}
              >
                <Img src="/private_notes.png" className="nvd-icon" />
                <div className="v grow">
                  <Txt sb className="nvd-text">
                    Internal notes for Ops
                  </Txt>
                  <Txt className="nvd-text" fs={12} color={cA4A4A4}>
                    This will not be visible to the Care Owners and Care Pros
                  </Txt>

                  <Txt className="nvd-text" mt={16} mb={6}>
                    About Care Recipient
                  </Txt>
                  <InputField
                    type="text"
                    className="nvd-text nvd-special-instructions nvd-ops-inst"
                    width="100%"
                    maxWidth="100%"
                    readOnly={isReadOnly}
                    lineHeight={22}
                    maxLines={200}
                    multiLine
                    noAutoSelect
                    blurOnTabKey
                    dontAnimate={state._disableAnim}
                    onTextChange={(_: any, t: string) => {
                      self._onPropChange(internal_ops_cr_note, t);
                      self._changeTextHeight(_);
                    }}
                    text={opsCRNote}
                  />

                  <Txt className="nvd-text" mt={16} mb={6}>
                    Fulfillment
                  </Txt>
                  <InputField
                    type="text"
                    className="nvd-text nvd-special-instructions nvd-ops-inst"
                    width="100%"
                    maxWidth="100%"
                    readOnly={isReadOnly}
                    lineHeight={22}
                    maxLines={200}
                    multiLine
                    noAutoSelect
                    blurOnTabKey
                    dontAnimate={state._disableAnim}
                    onTextChange={(_: any, t: string) => {
                      self._onPropChange(internal_ops_fulfillment_note, t);
                      self._changeTextHeight(_);
                    }}
                    text={fulfillmentNote}
                  />
                </div>
              </div>
              {((!isReadOnly && !isUpdating) || customerReqSrc) && (
                <div
                  className="nvd-row h center nvd-cust-src"
                  is-b2b={_attr(isB2b(props.crInfo))}
                  has-error={self._hasError(customer_request_origin)}
                >
                  <Img src="/customer_source.png" className="nvd-icon" />
                  <i className="nvd-star">*</i>
                  <Div ml={-8} vref={self._reqOriginRef} />
                  <TextDropdown
                    dontAnimate
                    items={
                      isB2b(props.crInfo)
                        ? B2B_VISIT_SOURCE_OPTIONS
                        : VISIT_SOURCE_OPTIONS
                    }
                    titleProperty="name"
                    readOnly={isReadOnly}
                    disabled={customerReqSrcDisabled}
                    popupDisabled={isReadOnly || customerReqSrcDisabled}
                    placeholder="How did the customer request for this visit?"
                    selectedItem={customerReqSrc}
                    onChange={(_: any, t: any) =>
                      t &&
                      !VISIT_SOURCE_DISABLED.includes(t.name) &&
                      self._onPropChange(customer_request_origin, t.name)
                    }
                  />
                  {state._showErrors === customer_request_origin && (
                    <span className="nvd-error nvd-err-long">
                      <img
                        alt="error"
                        src="/warning_red.png"
                        className="nvd-error-icon"
                      />
                      Please select a request source
                    </span>
                  )}
                </div>
              )}
              {!isUpdating && (
                <Div
                  className="nvd-row h"
                  has-error={_attr(!custReqDateString)}
                  maxH={43}
                >
                  <Img src="/visit_history.png" className="nvd-icon" />
                  <Div ml={-8} />
                  <div className="v">
                    {/* Date & time of client request */}
                    <span className="nvd-date-time-of-req">
                      Date &amp; time of client request
                    </span>
                    <div className="h">
                      <DateTimeDisplay
                        className="nvd-dtd"
                        region={this.props.region}
                        readOnly={isReadOnly}
                        dontAnimate={state._disableAnim}
                        startDate={
                          custReqDateString
                            ? convertToDestTZ(
                              parseDate(custReqDateString),
                              this.props.region
                            )
                            : UNDEF
                        }

                        singleDateMode
                        dontAllowPastDates
                        boldToday
                        onChange={(d: Date) =>
                          d &&
                          self._onPropChange(
                            customer_requested_at,
                            toISOLocal(d)
                          )
                        }
                      />
                      <TimePicker
                        placeholder="time"
                        style={s_tp}
                        readOnly={isReadOnly}
                        dontAnimate={state._disableAnim}
                        width="100%"
                        timeEntries={VisitDialog.timeEntries}
                        popupDisabled={isReadOnly}
                        selectedItem={custReqTime}
                        onChange={(mt: any) =>
                          self._updateCustReqTime(mt, custReqDateString)
                        }
                      />
                    </div>
                  </div>

                  <span className="nvd-error nvd-flex-top">
                    <img
                      alt="error"
                      src="/warning_red.png"
                      className="nvd-error-icon"
                    />
                    Please select Date &amp; time
                  </span>
                </Div>
              )}
            </div>

            {
              /* Custom repeat mode */
              !isReadOnly && viewtypeCustomRepeat && (
                <div
                  className="nvd-text nvd-cr"
                  data-visible={_attr(viewtypeCustomRepeat)}
                >
                  <span className="nvd-cr-starting-from">
                    Starting on{" "}
                    <Txt inline m>
                      {formatDate(visit.startDate)}
                    </Txt>
                  </span>
                  <Div className="h center" mv={20} mh={0}>
                    <Txt mr={18}>Repeat every</Txt>
                    <InputField
                      type="number"
                      min={1}
                      max={30}
                      className="nvd-mt-help nvd-cr-input"
                      width="56px"
                      maxWidth="56px"
                      lineHeight={19}
                      blurOnTabKey
                      dontAnimate={state._disableAnim}
                      onTextChange={(_e: any, t: string) =>
                        self._onRepeatCountChange(t)
                      }
                      text={(repeatMode.repeat_count || 1) + ""}
                    />

                    <TextDropdown
                      inputClassName="nvd-mt-help nvd-cr-input"
                      style={s_ml10}
                      width="88px"
                      showDropdownArrow
                      dontAnimate={state._disableAnim}
                      items={self._getRepeattypes()}
                      selectedItem={self
                        ._getRepeattypes()
                        .find((t: string) =>
                          t.startsWith(repeatMode.repeat_type)
                        )}
                      onChange={(_comp: any, selectedItem: string) =>
                        self._onRepeattypeChange(selectedItem)
                      }
                    />
                  </Div>

                  {repeatMode.repeat_type.startsWith("Day") && (
                    <div className="nvd-cr-day-mode">
                      <Calendar
                        onDateSelected={(d: any) =>
                          self._onRepeatModeDateSelected(d)
                        }
                        selectedDates={repeatMode.custom_dates}
                        //validFirstDate={visit.startDate}
                        dontAllowPastDates
                        boldToday
                        disableAfterMonths={12} // For now allow only 12 months bookings in advance
                        multiSelection
                      />
                    </div>
                  )}

                  {repeatMode.repeat_type.startsWith("Week") && (
                    <div className="nvd-cr-week-mode">
                      <div>Repeat on</div>
                      <div className="h">
                        {getShortWeekDays(firstDayOfWeek()).map(
                          (day: string) => (
                            <button
                              className="nvd-cr-wd"
                              key={day}
                              onClick={(e: any) =>
                                blur(e) &&
                                self._onWeekDayClick(
                                  getShortWeekDays().indexOf(day)
                                )
                              }
                              data-selected={(repeatMode.repeat_on || []).find(
                                (i: number) =>
                                  getShortWeekDays().indexOf(day) === i
                              )}
                            >
                              {day[0]}
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  )}

                  {repeatMode.repeat_type.startsWith("Month") && (
                    <div className="nvd-cr-month-mode">
                      <TextDropdown
                        inputClassName="nvd-mt-help nvd-cr-input"
                        dontAnimate={state._disableAnim}
                        items={self._getMonthlyDropdownItems()}
                        selectedItem={
                          self._getMonthlyDropdownItems()[
                          repeatMode.repeat_on_month_day ? 0 : 1
                          ]
                        }
                        onChange={(_: any, selectedItem: string) =>
                          self._onMonthlyDropdownClick(selectedItem)
                        }
                      />
                    </div>
                  )}

                  <Div mt={8}>Ends</Div>

                  <Div
                    className="h center ha-rb"
                    margin="16px 0 16px -10px"
                    onClick={() => self._onEndstypeChange(true)}
                  >
                    <Radio checked={repeatMode.is_ending_exact_date} />
                    <Txt width={74}>On</Txt>
                    <DateTimeDisplay
                      inputClassName="nvd-mt-help nvd-cr-input"
                      region={this.props.region}
                      dontAnimate={state._disableAnim}
                      startDate={repeatMode.ends_on_date || new Date()}
                      lineHeight={19}
                      singleDateMode
                      dontAllowPastDates
                      boldToday
                      onChange={(date: Date) => self._onEndsOnDateChange(date)}
                    />
                  </Div>

                  <Div
                    className="h center ha-rb"
                    onClick={() => self._onEndstypeChange(false)}
                    margin="0 0 0 -10px"
                  >
                    <Radio checked={!repeatMode.is_ending_exact_date} />
                    <Txt width={74}>After</Txt>

                    <InputField
                      type="number"
                      min={1}
                      max={180}
                      className="nvd-mt-help nvd-cr-input nvd-cr-after"
                      width="57px"
                      maxWidth="57px"
                      lineHeight={19}
                      blurOnTabKey
                      dontAnimate={state._disableAnim}
                      onTextChange={(e: any, t: string) =>
                        self._onEndsAfterCountChange(t)
                      }
                      text={(repeatMode.ends_after || DEF_ENDS_AFTER) + ""}
                    />

                    <TextDropdown
                      inputClassName="nvd-mt-help nvd-cr-input"
                      style={s_mlm4}
                      width="110px"
                      showDropdownArrow
                      dontAnimate={state._disableAnim}
                      items={self._getAftertypes(
                        repeatMode.ends_after || DEF_ENDS_AFTER
                      )}
                      selectedItem={self
                        ._getAftertypes(repeatMode.ends_after || DEF_ENDS_AFTER)
                        .find((t: string) =>
                          t.startsWith(repeatMode.ends_after_type || "")
                        )}
                      onChange={(_: any, selectedItem: string) =>
                        self._onAftertypeChange(selectedItem)
                      }
                    />
                  </Div>
                </div>
              )
            }

            {/* Additional Requirements */}
            {!isReadOnly && viewtypeAdditionalDetails && (
              <AdditionalRequirements
                visit={visit}
                onPropChange={self._onPropChange}
                onPropChangeThatProducesArrayOutput={self._onPropChangeThatProducesArrayOutput}
                onToggle={self._toggle}
                dontAnimate={state._disableAnim}
                isMobilityCDEWithSpecificServices={self._isRecipientMobilityCDEWithSpecificServicesforSingapore(visit)}
              />
            )}

            {(viewtypeCancelVisit || (!isReadOnly && viewtypeUpdateVisit)) && (
              <DialogCompUpdateVisit
                ref={self._updCancelCompRef}
                visible
                isUpdate={viewtypeUpdateVisit}
                data={state._updateVisitProps}
                updateCallback={(newProps: UpdateVisitProps) =>
                  self.setState({ _updateVisitProps: newProps })
                }
              />
            )}

            {viewtypePatientDecl && !isReadOnly && (
              <div data-visible={_attr(viewtypePatientDecl)}>
                <PatientDeclaration
                  symptomsList={(props.data && props.data.symptoms) || []}
                  homeMedDetails={homeMedicalDetails}
                  onUpdate={(details) => {
                    visit[home_medical_details] = details;
                  }}
                />
              </div>
            )}

            {viewtypeMedEscort && !isReadOnly && (
              <div data-visible={_attr(viewtypeMedEscort)}>
                <MedicalEscort
                  startDate={visit.startDate}
                  endDate={visit.endDate}
                  medEscortDetails={visit[medical_escort_details] || {}}
                  region={this.props.region}
                  onUpdate={(details) => {
                    visit[medical_escort_details] = details;
                  }}
                />
              </div>
            )}
            <PreferredCareProsSubView
              isReadOnlyMode={isReadOnly}
              isCurrentViewTypePreferredCarePros={viewtypePreferredCarePros}
              thereAreHomePersonalCareServicesSelected={visit[requested_services]?.length > 0 || visit[nursing_procedure]?.length > 0}
              thereAreHomeTherapyServicesSelected={visit[home_rehabilitation]?.length > 0}
              thereAreHomeMedicalServicesSelected={visit[home_medical]?.length > 0}
              apiDropdownData={props.preferred_cps_list_by_service}
              previousVisitCarePros={prevVisit?.preferred_cps_list_by_service}
              currentVisitCarePros={this.state.current_selected_preferred_care_pros}
              onChange={(data) => this.setState({ current_selected_preferred_care_pros: { ...data } })}
            />
          </div>

          <div className="nvd-line nvd-full-length" />

          {/* Fee breakdown for Visit details  */}
          {isReadOnly && !viewtypeCancelVisit && paymentBreakdown && (
            <div className="h justified center no-shrink">
              <div className="nvd-text">
                Estimated Fees:{" "}
                <b>
                  {self._getEstimatedFees(
                    paymentBreakdown,
                    visit.careowner_penalties
                  )} {self._showGSTText(paymentBreakdown)}
                </b>
              </div>
              <Button
                className="ha-dialog-done nvd-breakdown-btn"
                onClick={() =>
                  window.open(SMILEY_VISIT_DETAILS + visit._id + "?tab=fees")
                }
              >
                Fee breakdown
              </Button>
            </div>
          )}

          {(!isReadOnly || viewtypeCancelVisit) && (
            <div className="h justified center">
              {/* Additional requirements selection popup from listview */}
              {isSubDialog && !self._isUpdate && (
                <Button
                  tabIndex={0}
                  className="ha-dialog-done nvd-done-all"
                  onClick={() => self.close(false, true)}
                >
                  Apply to selected visits
                </Button>
              )}

              <Txt
                className="nvd-text"
                color={!state._visitsCount ? "red" : ""}
                invisible={isReadOnly || isSubDialog || isUpdating}
              >
                <b>{state._visitsCount}</b>
                {` visit${state._visitsCount > 1 ? "s" : ""} to be created`}
              </Txt>

              <Button
                onClick={(e) => { self._onDoneBtnClick(visit) }}
                color="primary"
                className="ha-btn-green"
                variant="contained"
                disabled={self._doneBtnDisabled(
                  visit,
                  isUpdating,
                  state._visitsCount,
                  viewtype,
                  dialogtype
                )}
              >
                <span>{self._doneBtnText(isUpdating, viewtype)}</span>
              </Button>
            </div>
          )}
        </div>

        {state._showConfirmation && (
          <OkCancelDialog
            title="Discard Changes?"
            message="Would you like to discard unsaved changes?"
            cancelText="Cancel"
            okText="Discard"
            callback={(btnIndex: number) =>
              self._onDiscardChanges(btnIndex === 2)
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { recipientStore, visitStore, visitDraftStore } = state;

  const details = recipientStore && recipientStore.careRecipient;
  const { cr } = details;
  const vwo = cr && cr.vwo && cr.vwo[0];
  const vwoId = (vwo && vwo._id) || UNDEF;

  return {
    ...state,
    data: visitDraftStore,
    crInfo: recipientStore?.careRecipient?.cr,
    preferred_cps_list_by_service: recipientStore?.careRecipient?.cr?.preferred_cps_list_by_service,
    previousVisit: visitStore?.previousVisit,
    states: recipientStore?.states,
    vwoId: vwoId,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
});

export default connect<VisitDialogStatePropsType, VisitDialogConnectPropsType>(
  mapStateToProps,
  mapDispatchToProps
)(VisitDialog)

// end VisitDialog component

const s_tp = { width: 85, marginLeft: 8 };
const s_ml10 = { marginLeft: 10 };
const s_mlm4 = { marginLeft: -4 };

export const isSelected = (visit: any, prop: string) =>
  visit[prop] ? "" : UNDEF;
export const isNotSelected = (visit: any, prop: string, explicit = true) =>
  (explicit ? visit[prop] === false : !visit[prop]) ? "" : UNDEF;
